import React, { useMemo, useEffect, Suspense, useState, useRef } from 'react'
import classes from "./DevicesList.module.css";
import ListCard from './ListCard';
import BasicTable from '../Table/Table/Table';
import { Await, Link, useLoaderData, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loading-icons';
import UseDateFormat from '../hooks/UseDateFormat';
import Pill_Widget from '../UI/Widgets/Pill_Widget';
import DropdownList from '../UI/Cards/DropdownList';
import SettingsCog from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings.png"
import { useDispatch, useSelector } from 'react-redux';
import { addSitesToGroup, changeCamectIntegration, changeRole, clearDeviceLogs, copyIPIOSettings, copyUsersToAnotherDevice, getDevices, getGroups, getRandomUIPIOID, rebootIPIODevice, removeUser, resetIPIODevice, setSiteActive, setSiteLiveView, suspendDevice, suspendUser, updateSiteDetails } from '../../Api Methods/Api';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../hooks/UseSetCookie';
import Modal from '../Modal/Modal';
import DropDownForm from '../forms/DropDownForm';
import DropdownCustom from '../../components/forms/DropdownCreateGroup'
import DataManager from '../../hooks/DataManager';
import GridPaginationControls from '../Table/Table/GridPaginationControls';
import OutputPinCircle from '../UI/DataLayouts/OutputPinCircle';
import InputPinCircle from '../UI/DataLayouts/InputPinCircle';
import useParseArrayDeviceData from '../hooks/useParseArrayDeviceData';
import SetTag from '../Modal/ModalLayouts/SetTag';
import Button1 from '../UI/Button/Button1';
import CopyUsersPowersearch from '../../components/hooks/PowerSearchCopySettings'
import gateway_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortal.png'
import ajax_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import hik_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import aibox_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import dahua_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import camect_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/camectIconPortal.png'

import live_view_icon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/live-view.png'
import SetNameForUsers from '../Modal/ModalLayouts/SetName';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import SuspendIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/suspend.png'
import ClearLogsIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/clearLogs.png'
import ChangePortalNameIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png'
import ChangeSerialIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/serial.png'
import CamectIntegrationIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/camectIntegration.png'
import CopyConfigIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/copyConfig.png'
import RebootIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reboot.png'
import ResetIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/reset.png'
import AddToGroupIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/addToGroup.png'
import revokeAccess from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/revoke.png'
import ChangeRole from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png'
import { da, se } from 'date-fns/locale';
import { add, format } from 'date-fns';
import Input from '../CustomDropDown/Input/Input';
import SearchBar from '../PowerSearch/SearchBar';
import SetPortalName from '../Modal/ModalLayouts/SetPortalName';
import ChangeGroup from '../Modal/ModalLayouts/ChangeGroup';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import CreateHolidayMode from '../UI/Cards/Automations/HolidayMode/CreateHolidayMode';
import { SelectButton } from 'primereact/selectbutton';
import InviteExistingUserForm from '../forms/InviteExistingUserForm';
import MassAddUserForm from '../forms/MassAddUserForm';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import SetSerial from '../Modal/ModalLayouts/SetSerial';
import { InputSwitch } from 'primereact/inputswitch';
import Pill_Widget_2 from '../UI/Widgets/Pill_Widget_2';

import loadingAnim from '../../assets/animations/newLoading.json'
import CopySiteConfigForm from '../forms/CopySiteConfigForm';
import CreateMassScheduleForm from '../forms/CreateMassScheduleForm';
import { ConfirmDialog } from 'primereact/confirmdialog';
import SelectGroupDialog from '../CustomDropDown/SelectGroupDialog';
import areYouSure from '../../assets/animations/areYouSure.json'
import Lottie from 'lottie-react';
import { socket } from '../../Socket/socket';
import parsePinStates from '../../Socket/parsePinStates';

const DevicesList = ({ devices, filtering, HandleSaveSearchQuery, totalPages, setTotalPages, pageFetchedIndex, setPageFetchedIndex, pageSize, setPageSize, totalDevices, setTotalDevices, isUsersSites, groupMode, update, setUpdate, hideControls, offlineOnly, isSortable, editUserAccess, sitesToRemove, setSitesToRemove, HandleGiveAccess, sitesForGroup, setSitesForGroup, sitesForGroupMode, setSitesForGroupMode, selectAllCancelled, showMassSelect, showMassSettings, setShowMassSettings, liveViewOnly, isLiveViewSites, isGroupSites }) => {

  const [SiteDevices, setSiteDevices] = useState(devices)
  const [pinStatesByUUID, setPinStatesByUUID] = useState({})

  console.log(devices);

  const token = useSelector(state => state.auth.token);
  const client = useSelector(state => state.auth.client);
  const company = useSelector(state => state.auth.companyName);
  const role = useSelector(state => state.auth.role);
  const dataManager = new DataManager();
  const parsedData = useParseArrayDeviceData(devices);
  const [suggestions, setSuggestions] = useState([]);
  const [selectionMade, setSelectionMade] = useState(false);
  const [siteID, setSiteID] = useState();
  const [copyUsersChecked, setCopyUsersChecked] = useState(dataManager.getItem('copyUsersChecked'));
  const [autoChooseASiteChecked, setAutoChooseASiteChecked] = useState(dataManager.getItem('autoChooseASite'));
  const [deviceKey, setDeviceKey] = useState("");
  const [queryDeviceList, setQueryDeviceList] = useState("");
  const [myUserID, setMyUserID] = useState("");
  const [nameSet, setNameSet] = useState('');
  const [deviceType, setDeviceType] = useState("");
  const [redraw, setRedraw] = useState(0)
  let newSiteUUID = "";
  const [selectedGroup, setSelectedGroup] = useState(null)
  const addAccessMode = dataManager.getItem('isAddAccessMode')
  const [checkedItems, setCheckedItems] = useState(dataManager.selectedSites.value || []);
  const loggedInAs = useSelector(state => state.auth.companyName);
  const userID = useSelector(state => state.auth.userID);
  const DeviceKey = localStorage.getItem("DeviceKey")
  const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [removeSubUsersDialogVisible, setRemoveSubUsersDialogVisible] = useState(false)
  const [pendingRemoveAction, setPendingRemoveAction] = useState(null)
  const apiData = { token, client }
  const dropdownRef = useRef(null);
  const ModalDialog = useRef();
  const [modalTitle, setModalTitle] = useState("title")
  const [modalComponent, setModalComponent] = useState()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [columnVisibility, setColumnVisibility] = useState(() => JSON.parse(localStorage.getItem('columnVisibility')) || {});
  const columnOrderKey = liveViewOnly ? 'columnOrder_liveView' : isUsersSites ? 'columnOrder_userSites' : offlineOnly ? 'columnOrder_offline' : 'columnOrder';
  const [columnOrder, setColumnOrder] = useState(() => JSON.parse(localStorage.getItem(columnOrderKey)) || []);
  const [selectAll, setSelectAll] = useState(null)
  const [portalName, setPortalName] = useState("")
  const [setNewPortalName, setSetNewPortalName] = useState(false)
  const [checkedSites, setCheckedSites] = useState([])
  const [selectAllSites, setSelectAllSites] = useState(false)
  const [selectedMassAction, setSelectedMassAction] = useState("")
  const [changeBillable, setChangeBillable] = useState(false)
  const [showSelectBilledToDialog, setShowSelectBilledToDialog] = useState(false)
  const [showSelectOwnerDialog, setShowSelectOwnerDialog] = useState(false)
  const [showSelectCustomerBilledToDialog, setShowSelectCustomerBilledToDialog] = useState(false)
  const [showDateOfSaleDialog, setShowDateOfSaleDialog] = useState(false)
  const [showInvoiceDateDialog, setShowInvoiceDateDialog] = useState(false)
  const [showDateMadeActiveDialog, setShowDateMadeActiveDialog] = useState(false)
  const [showBillingFrequencyDialog, setShowBillingFrequencyDialog] = useState(false)
  const [showSiteTypeDialog, setShowSiteTypeDialog] = useState(false)
  const [showSiteLocationDialog, setShowSiteLocationDialog] = useState(false)
  const [newDateOfSale, setNewDateOfSale] = useState(null)
  const [newInvoiceDate, setNewInvoiceDate] = useState(null)
  const [newDateMadeActive, setNewDateMadeActive] = useState(null)
  const [newBillingFrequency, setNewBillingFrequency] = useState(null)
  const [newBillableStatus, setNewBillableStatus] = useState(null)
  const [newSiteType, setNewSiteType] = useState(null)
  const [newSiteLocation, setNewSiteLocation] = useState(null)
  const [holidayModeType, setHolidayModeType] = useState("")
  const [success, setSuccess] = useState(false)
  const [failure, setFail] = useState(false)
  const [message, setMessage] = useState("")
  const [modalMessageSuccess, setModalMessageSuccess] = useState("")
  const [modalMessageFail, setModalMessageFail] = useState("")
  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isCreateScheduleOpen, setIsCreateScheduleOpen] = useState(false);

  const [columnSettingsVisible, setColumnSettingsVisible] = useState(false)
  const [addToGroupVisible, setAddToGroupVisible] = useState(false)
  const [isMassAction, setIsMassAction] = useState(false)
  const [UUID, setUUID] = useState("")
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [currentSitePosition, setCurrentSitePosition] = useState(1)
  const [currentUserPosition, setCurrentUserPosition] = useState(1)
  const [totalUsers, setTotalUsers] = useState(0)

  //Dialogs
  //Copy config
  const [copyConfigData, setCopyConfigData] = useState(null)

  console.log(devices);

  const GetGroups = async () => {
    try {
      const listOptions = await getGroups(apiData, dispatch);
      setGroups(listOptions || []);
    } catch (error) {
      console.error('Failed to fetch groups:', error);
      setGroups([]);
    }
  };

  useEffect(() => {
    GetGroups();
  }, []);

  useEffect(() => {
    const visibleSiteUUIDS = []
    for (const device of devices){
      if (!visibleSiteUUIDS.includes(device.uuid)){
          visibleSiteUUIDS.push(device.uuid)
      }
    }

    for (const uuid of visibleSiteUUIDS){
      socket.emit("routeCommand", {
          cmd: "getStates",
          uuid: uuid
      })
    }
  }, [devices])

  useEffect(() => {
    let buffer = {};
    let flushTimeout = null;

    const flush = () => {
      setPinStatesByUUID((prev) => ({ ...prev, ...buffer }));
      buffer = {};
      flushTimeout = null;
    };

    const HandlePinStates = (data) => {
      buffer[data.uuid] = parsePinStates(data);
      if (!flushTimeout) {
        flushTimeout = setTimeout(flush, 300);
      }
    };

    socket.on('appPinStates', HandlePinStates);

    return () => {
      socket.off('appPinStates', HandlePinStates);
      if (flushTimeout) clearTimeout(flushTimeout);
    };
  }, [])

  const toggleColumnVisibility = (key, currentVisible) => {
    setColumnVisibility(prev => {
      const next = { ...prev, [key]: !currentVisible };
      localStorage.setItem('columnVisibility', JSON.stringify(next));
      return next;
    });
  };

  const moveColumn = (key, direction) => {
    const naturalOrder = tablecolumns.filter(col => col.filterLabel).map(col => col.id);
    setColumnOrder(prev => {
      const current = prev.length ? prev : naturalOrder;
      const idx = current.indexOf(key);
      if (idx === -1) return current;
      const next = [...current];
      const swapIdx = idx + direction;
      if (swapIdx < 0 || swapIdx >= next.length) return current;
      [next[idx], next[swapIdx]] = [next[swapIdx], next[idx]];
      localStorage.setItem(columnOrderKey, JSON.stringify(next));
      return next;
    });
  };

  const HandleNextPage = () => {
    setPageFetchedIndex(prevPageFetchedIndex => prevPageFetchedIndex + 1)
    dataManager.setItem('pageIndex', prevPageFetchedIndex => prevPageFetchedIndex + 1)
  }

  const HandlePreviousPage = () => {
    setPageFetchedIndex(prevPageFetchedIndex => prevPageFetchedIndex - 1)
    dataManager.setItem('pageIndex', prevPageFetchedIndex => prevPageFetchedIndex - 1)
  }

  const HandleSetPageIndex = (pageFetchedIndex) => {
    setPageFetchedIndex(pageFetchedIndex)
  }

  const HandlePageSize = (PageSize) => {
    setPageSize(PageSize);
    dataManager.setItem('pageSize', PageSize)
    HandlePageCount(totalPages);
    dataManager.setItem('totalPages', totalPages)
  }

  const HandlePageCount = (totalPages) => {
    setTotalPages(totalPages);
  }

  useEffect(() => {

    if (selectAll == null) {
      return
    }

    if (selectAll) {
      if (addAccessMode) {
        const devices = SiteDevices.map(device => ({
          deviceID: device.id,
          name: device.tag != "" ? device.tag : device.key
        }));

        setCheckedItems(devices)
      } else if (groupMode && !sitesForGroupMode) {
        const deviceUUIDs = SiteDevices.map(device => device.uuid);

        setCheckedItems(deviceUUIDs);
      } else if (isUsersSites && !sitesForGroupMode) {
        const devices = SiteDevices.map(device => ({
          deviceUUID: device.uuid,
          deviceID: device.deviceID,
        }));

        setSitesToRemove(devices);
      } else if (sitesForGroupMode) {
        const deviceUUIDs = SiteDevices.map(device => device.uuid);
        setSitesForGroup(deviceUUIDs);
      }
    }
    else {
      if (addAccessMode || groupMode) {
        setCheckedItems([]);
      } else if (isUsersSites && !sitesForGroupMode) {
        setSitesToRemove([]);
      } else if (sitesForGroupMode) {
        setSitesForGroup([])
      }
    }
  }, [selectAll, SiteDevices]);


  useEffect(() => {
  }, [sitesToRemove])

  useEffect(() => {
  }, [checkedItems])

  useEffect(() => {
  }, [sitesForGroup])

  useEffect(() => {

    if (dataManager.getItem('isAddAccessMode')) {
      const existingSites = dataManager.getItem('existingSites') || [];
      const existingUUIDs = new Set(existingSites.map(site => site.uuid));
      const filteredDevices = devices.filter(device => !existingUUIDs.has(device.uuid));
      setSiteDevices(filteredDevices);
    } else {
      setSiteDevices(devices);
    }
    dataManager.setItem('pageIndex', pageFetchedIndex)
  }, [pageFetchedIndex, pageSize, devices])

  const HandleChangeOwner = async (result) => {
    const data = await devices;
    const updatedData = data.map(row => {
      if (row.uuid === result.DeviceUUID) {
        return { ...row, name: result.dropDown };
      }
      return row;
    });

    setSiteDevices(updatedData);
  };

  const handleSettingsClick = (rowId) => {
    // If the clicked dropdown is already open, close it
    if (openDropdownRowId === rowId) {
      setOpenDropdownRowId(null);
    } else {
      // Otherwise, open the clicked dropdown
      setOpenDropdownRowId(rowId);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Clicked outside the dropdown menu, so close it
        setOpenDropdownRowId(null);
      }
    };

    // Add event listener to listen for clicks outside the dropdown menu
    document.addEventListener('click', handleClickOutside);

    return () => {
      // Cleanup: Remove event listener when component unmounts
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setSuggestions([])
    setQueryDeviceList("")
    setSelectionMade(false)
    setSiteID("")
    setCopyUsersChecked(false)
    dataManager.setItem('copyUsersChecked', false);
    dataManager.setItem('setNameCopyUsers', "")
    setSelectedMassAction("")
  }

  // useEffect(() => {
  //   if ((suggestions.length > 0) || ((redraw > 0) && queryDeviceList !== "")) {
  //     showCopySiteSettingsModal(deviceKey);
  //   }
  // }, [suggestions, redraw])

  useEffect(() => {
    if (queryDeviceList !== "" && queryDeviceList !== " " && queryDeviceList !== null) {
      //showCopySiteSettingsModal(deviceKey);
    } else {
      setSuggestions([])
    }
    //This is to rerender the modal and show the new data in the query
  }, [queryDeviceList])

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  }

  // const updateSiteID = (siteID) => {
  //   setQueryDeviceList(siteID);
  //   setSuggestions([]);
  //   dataManager.setItem('siteIDToCopyTo', siteID);
  //   setRedraw(redraw + 1)
  //   setSelectionMade(true);
  // }

  // const selectAnEmptySite = (event) => {
  //   setAutoChooseASiteChecked(event.target.checked);
  //   dataManager.setItem('autoChooseASite', event.target.checked);
  //   showCopySiteSettingsModal(deviceKey);
  // }

  // useEffect(() => {
  //   console.log(portalName)
  // }, [portalName])

  // const showCopySiteSettingsModal = (DeviceKey, type, deviceUUID) => {
  //   dataManager.setItem('setPortalGroup', "")
  //   dataManager.setItem('changePortalGroupForReset', "")
  //   setModalTitle("Copy configuration of: " + DeviceKey)
  //   setModalComponent(
  //     <div>
  //       {(<div>
  //         <label>
  //           <input
  //             type="checkbox"
  //             checked={dataManager.getItem('autoChooseASite')}
  //             onChange={selectAnEmptySite}
  //           />
  //           Automatic site selection
  //         </label>
  //         <br></br>
  //         {dataManager.getItem('autoChooseASite') &&
  //           <p style={{ color: "#4C4C4C" }}>The system will select a site ID with no users that is not named.</p>}
  //       </div>)}

  //       <br></br>

  //       {!dataManager.getItem('autoChooseASite') && (
  //         <div>
  //           <div>
  //             <CopyUsersPowersearch apiData={apiData} update={update} setUpdate={setUpdate} suggestions={suggestions} setSuggestions={setSuggestions} queryDeviceList={queryDeviceList} setQueryDeviceList={setQueryDeviceList} redraw={redraw} setRedraw={setRedraw} />
  //           </div>

  //           {suggestions.length > 0 && (
  //             <ul
  //               style={{
  //                 listStyle: 'none',
  //                 margin: 0,
  //                 padding: '0px',
  //                 border: '1px solid #ccc',
  //                 borderRadius: '4px',
  //                 position: 'absolute',
  //                 width: '94%',
  //                 backgroundColor: '#fff',
  //                 zIndex: 1000,
  //               }}
  //             >
  //               {suggestions.map((suggestion, index) => (
  //                 <li
  //                   key={index}
  //                   onClick={() => updateSiteID(suggestion)}
  //                   style={{
  //                     padding: '8px',
  //                     cursor: 'pointer',
  //                     borderBottom: '1px solid #ddd',
  //                   }}
  //                 >
  //                   {suggestion}
  //                 </li>
  //               ))}
  //             </ul>
  //           )}

  //           <div
  //             style={{
  //               flexDirection: "column",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               textAlign: "center"
  //             }}
  //           >
  //             <p style={{ color: "#4C4C4C" }}>{`Please note, only sites without a name or users will appear in search suggestions.`}</p>
  //             <p style={{ color: "#4C4C4C" }}>{`If a site isn't listed, you can still copy to it by entering its Site ID.`}</p>
  //           </div>
  //         </div>
  //       )}

  //       <br></br>

  //       <div>
  //         <label>
  //           <input
  //             type="checkbox"
  //             checked={dataManager.getItem('setPortalNameSelected')}
  //             onChange={handleSetPortalNameSelected}
  //           />
  //           Set portal name?
  //         </label>
  //         <br></br>
  //       </div>

  //       {dataManager.getItem('setPortalNameSelected') &&
  //         <SetPortalName
  //           placeholder={"Portal name"}
  //           HandleCloseModal={HandleCloseModal}
  //           setNameSet={setPortalName}
  //         />}

  //       <br></br>

  //       <div>
  //         <label>
  //           <input
  //             type="checkbox"
  //             checked={dataManager.getItem('setPortalGroupSelected')}
  //             onChange={handleSetGroupSelected}
  //           />
  //           Add to a group?
  //         </label>
  //         <br></br>
  //       </div>

  //       {dataManager.getItem('setPortalGroupSelected') && <div>
  //         <ChangeGroup
  //           apiData={apiData}
  //           DeviceUUID={""}
  //           companyName={""}
  //           NotificationTitle={""}
  //           label={"Please select a new group below"}
  //           dropDownOptions={groups
  //             .map(group => group.name)
  //             .sort((a, b) => a.localeCompare(b))
  //           }
  //           HandleCloseModal={HandleCloseModal}
  //           update={update}
  //           setUpdate={setUpdate}
  //           SiteDevices={SiteDevices}
  //           setSiteDevices={setSiteDevices}
  //         />
  //       </div>}

  //       <div>
  //         <br></br>
  //         <label>
  //           <input
  //             type="checkbox"
  //             checked={dataManager.getItem('copyUsersChecked')}
  //             onChange={handleCopyUsersSelected}
  //           />
  //           Copy users?
  //         </label>
  //         <br></br>
  //       </div>
  //       {dataManager.getItem('copyUsersChecked') && (
  //         <div>
  //           <SetNameForUsers
  //             placeholder={"Name of site for new users in app and in portal:"}
  //             HandleCloseModal={HandleCloseModal}
  //             setNameSet={setNameSet}
  //           />
  //           <small>(Note, you can change this after)</small>
  //         </div>
  //       )}
  //       <br />
  //       <Button1 style={{ width: "100%" }} onClick={copySiteSettings}>Copy</Button1>
  //     </div>


  //   );

  //   HandleShowModal();
  // }

  const AddSiteToGroup = async () => {
    if (selectedGroup) {
      let body = {
        groupID: selectedGroup.id,
        groupName: selectedGroup.name,
        groupDevices: [UUID]
      }

      const response = await addSitesToGroup(apiData, body, dispatch);
      if (response.success) {
        setUpdate(update + 1);
        HandleCloseModal();
        setAddToGroupVisible(false)
        successModal("Site successfully added to group: " + selectedGroup.name, false);

        setSiteDevices((prevSiteDevices) =>
          prevSiteDevices.map((device) =>
            device.uuid === UUID ? { ...device, name: selectedGroup.name } : device
          )
        );
      } else {
        errorModal("Something went wrong, please try again", false);
      }
    } else {
      errorModal("Unable to find group, please try again", false);
    }
  }

  // ---------- carrys out clicked action in dropdown
  const UserActionHandler = (userAction, suspend, DeviceId, DeviceUUID, userID, DeviceName, DeviceKey, camectIntegationType, tag, row, DeviceDetails, type, subGroup, suspendUser) => {
    switch (userAction) {
      case 'Unsuspend Site':
      case 'Suspend Site':
        const SuspendDevice = async () => {
          const response = await suspendDevice(apiData, suspend, DeviceId, dispatch);
          if (response) {
            let status;

            if (row.status === "suspended") {
              status = "available"
            } else {
              status = "suspended"
            }
            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.map((device) =>
                device.uuid === DeviceUUID ? { ...device, status: status } : device
              )
            );
            successModal("Site is now " + status)
            setOpenDropdownRowId(null);
            setUpdate(prevUpdate => prevUpdate + 1);
          } else {
            errorModal("Something went wrong, please try again", false)
          }
        }
        SuspendDevice();
        break;
      case 'Clear Logs':
        const ClearLogs = () => {
          setOpenDropdownRowId(null);

          const HandleClearLogs = async () => {
            const response = await clearDeviceLogs(apiData, DeviceUUID, userID, dispatch);
            if (response.success) {
              HandleCloseModal();
              successModal("Logs cleared successfully", false)
            } else {
              errorModal("Something went wrong, please try again", false)
            }
          }

          const Cancel = () => {
            HandleCloseModal();
          }

          setModalTitle("Clear Logs");
          setModalComponent(
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                gap: "20px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems:"center",
                  flexDirection: "column",
                  width: "100%",
                  gap: "3px"
                }}
              >

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>

                <h3 style={{ fontSize:"20px", textAlign: "center", color: "#858585", marginBottom:"15px" }}>{"Are you sure you want to clear Device: " + DeviceKey + " log's?"}</h3>
                <h4 style={{  fontSize:"18px",textAlign: "center", margin: "0px", color: "red" }}>This action is permanent!</h4>
                
              </div>
          
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: "10px"
                }}
              >
                <Button icon="pi pi-times"  label="Cancel" severity="secondary" onClick={Cancel} />
                <Button
                  
                  onClick={() => HandleClearLogs()}
                  label="Yes, clear logs"
                  severity="danger"
                  icon="pi pi-trash" 
                />
              </div>
            </div>
          );
          
          HandleShowModal()
        }
        ClearLogs();
        break;
      case 'Change portal name':
        const ChangeTag = async () => {
          setOpenDropdownRowId(null);
          setModalTitle("Change portal name")
          setModalComponent(
            <SetTag
              placeholder={tag}
              DeviceUUID={DeviceUUID}
              HandleCloseModal={HandleCloseModal}
              dispatch={dispatch} update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
              successModal={successModal}
              errorModal={errorModal}
            />)
          HandleShowModal()
        }
        ChangeTag();
        break;
      case 'Change serial number':
        const ChangeSerialNumber = async () => {
          setOpenDropdownRowId(null);
          setModalTitle("Change serial number")
          setModalComponent(
            <SetSerial
              placeholder={subGroup}
              DeviceUUID={DeviceUUID}
              HandleCloseModal={HandleCloseModal}
              dispatch={dispatch} update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
              successModal={successModal}
              errorModal={errorModal}
            />)
          HandleShowModal()
        }
        ChangeSerialNumber();
        break;
      case 'Change group':
        const ChangeOwner = async (DeviceKey) => {
          setModalTitle("Change group of: " + DeviceKey)
          setModalComponent(<DropDownForm apiData={apiData} DeviceUUID={DeviceUUID} companyName={""} NotificationTitle={""} label={"Please select a new site group below"} dropDownOptions={['EyeSpyFX', 'RE:SURE', 'PARFAS', 'PORTAL_SECURITY', 'DCC', 'SOLO', 'CSC', 'CPS', 'EES', 'WEEBIG', 'KNOWIO', '12TH_LOCK']} HandleCloseModal={HandleCloseModal} update={update} setUpdate={setUpdate} SiteDevices={SiteDevices} setSiteDevices={setSiteDevices} />)
          setOpenDropdownRowId(null);
          HandleShowModal()
        }
        ChangeOwner(DeviceKey);
        break;
      case 'Change camect integration type':
        const Changecamectintergrationtype = async () => {
          const CamectIntegationType = camectIntegationType == 2 ? 1 : 2;
          const notificationMessage = CamectIntegationType == 1 ? "Whole Camect" : "Per Cam Arming"
          const response = await changeCamectIntegration(apiData, DeviceUUID, CamectIntegationType, DeviceName, dispatch)
          if (response) {
            successModal("Camect integration changed to " + notificationMessage)
            DeviceDetails.camectIntegrationType = CamectIntegationType;
            row.deviceDetails = JSON.stringify(DeviceDetails);
            setOpenDropdownRowId(null);
          } else {
            errorModal("Failed to change camect integration type, please try again")
          }
        }
        Changecamectintergrationtype();
        break;
      case 'Copy site configuration':
        setCopyConfigData({
          siteIdentifier: tag != "" && tag != null ? tag : DeviceKey,
          deviceFromUUID: DeviceUUID,
          deviceFromID: DeviceId,
          userID: userID,
        })
        break;
      case 'Reboot site':
        const RebootDevice = async () => {
          const response = await rebootIPIODevice(apiData, DeviceUUID, userID, DeviceName);
          setOpenDropdownRowId(null);
          if (response) {
            successModal("Site rebooting...")
          } else {
            errorModal("Failed to reboot site, please try again")
          }
        }
        RebootDevice();
        break;
      case 'Reset site':
        const ResetDevice = async () => {
          dataManager.setItem('setPortalGroup', "")
          dataManager.setItem('changePortalGroupForReset', "")
          setModalTitle("Are you sure?")
          setModalComponent(
            <div style={{display:"flex", flexDirection:"column", alignContent:"center", alignItems:"center"}}>
                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
              <br/>
              <div style={{ textAlign: "center" }}>
                 <h3 style={{ fontSize:"20px", textAlign: "center", color: "#858585", marginBottom:"8px" }}>Are you sure you want to reset: {DeviceKey}?</h3>
              </div>
              <p style={{ fontSize:"14px", textAlign: "center", color: "#858585", marginBottom:"5px" }}>This will revert all settings & customisations to factory default.</p>
              <p style={{ fontSize:"18px", textAlign: "center", color: "#fc4444", marginBottom:"15px" }}>This action cannot be undone!</p>

             
              <ChangeGroup
                apiData={apiData}
                DeviceUUID={""}
                companyName={""}
                NotificationTitle={""}
                label={"To change group, please select a new group below"}
                dropDownOptions={groups.map(group => group.name).sort((a, b) => a.localeCompare(b))}
                HandleCloseModal={HandleCloseModal}
                update={update}
                setUpdate={setUpdate}
                SiteDevices={SiteDevices}
                setSiteDevices={setSiteDevices}
              />
              <br></br>
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px"
              }}>
                <Button icon="pi pi-times"  onClick={HandleCloseModal} label='No, cancel' severity='secondary'/>
                <Button icon="pi pi-check" onClick={() => resetSite(apiData, DeviceUUID, userID, DeviceName, dispatch)} label="Yes, I'm sure" severity='danger'/>
              </div>
            </div>
          )
        }
        HandleShowModal();
        ResetDevice();
        break;
      case 'Add to group':
        setUUID(row.uuid)
        setAddToGroupVisible(true)
        //const ShowGroupsModal = async () => {
        //   const groupNames = groups.map(listOptions => listOptions.name);
        //   setModalTitle("Add site to group")
        //   setModalComponent(
        //     <div>
        //       <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} />
        //       <br></br>
        //       <Button1 onClick={() => AddSiteToGroup(row.uuid)}>Add to group</Button1>
        //     </div>

        //   )
        //   HandleShowModal();
        // }

        // ShowGroupsModal();

        break;
      case 'Change role':
        const HandleChangeUserAccess = async () => {
          const responseData = await changeRole(apiData, DeviceId, userID, row.role, row.userID, DeviceUUID, dispatch);
          if (responseData.success) {
            const newRole = row.role == 'user' ? 'manager' : 'user'
            const formattedNewRole = newRole == 'user' ? "app standard user" : "app manager"

            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.map((device) =>
                device.uuid === DeviceUUID ? { ...device, role: newRole } : device
              )
            );
            setOpenDropdownRowId(null);
            successModal(`User role successfully changed to ${formattedNewRole}`, false)
          } else {
            errorModal("Failed to change users role, please try again.", false)
          }
        }

        HandleChangeUserAccess()
        break;
      case 'Revoke access':
        // Temporarily disabled until backend supports includeSubUsers - revoke access directly as before
        // setPendingRemoveAction(() => async (includeSubUsers) => {
        //   const responseData = await removeUser(apiData, DeviceId, DeviceUUID, userID, row.userID, includeSubUsers, dispatch)
        //   if (responseData) {
        //     setSiteDevices((prevSiteDevices) =>
        //       prevSiteDevices.filter((device) => device.uuid !== DeviceUUID)
        //     );
        //     setOpenDropdownRowId(null);
        //     successModal("Access successfully revoked", false)
        //   } else {
        //     errorModal("Failed to revoke access, please try again.", false)
        //   }
        // });
        // setRemoveSubUsersDialogVisible(true);
        const HandleRevokeUserAccess = async () => {
          const responseData = await removeUser(apiData, DeviceId, DeviceUUID, userID, row.userID, false, dispatch)
          if (responseData) {
            setSiteDevices((prevSiteDevices) =>
              prevSiteDevices.filter((device) => device.uuid !== DeviceUUID)
            );
            setOpenDropdownRowId(null);
            successModal("Access successfully revoked", false)
          } else {
            errorModal("Failed to revoke access, please try again.", false)
          }
        }
        HandleRevokeUserAccess();
        break;
      case 'Suspend access':
      case 'Unsuspend access':
        suspendUser(apiData, row.userID, suspendUser, DeviceId).then((responseData) => {
          if (responseData) {
            setOpenDropdownRowId(null);

            successModal("Access changed successfully", false)
          }
        })
        break;
      default:
    }
  }

  const resetSite = async (apiData, DeviceUUID, userID, DeviceName, dispatch) => {
    const response = await resetIPIODevice(apiData, DeviceUUID, userID, DeviceName, dataManager.getItem('changePortalGroupForReset'), dispatch)
    if (response.success) {
      successModal("Site reset successfully!", false)
      setPageFetchedIndex(pageFetchedIndex)
      //HERE
      if (dataManager.getItem('changePortalGroupForReset') !== "") {
        const updatedDevices = devices.map(device =>
          device.uuid === DeviceUUID ? { ...device, name: dataManager.getItem('changePortalGroupForReset'), active: 0 } : device
        );
        setSiteDevices(updatedDevices)
      } else {
        const updatedDevices = devices.map(device =>
          device.uuid === DeviceUUID ? { ...device, active: 0, tag: "", deviceName: "", userCount: 0 } : device
        );
        setSiteDevices(updatedDevices)
      }
    }
    setOpenDropdownRowId(null);
  }

  const successModal = (message, isCopyConfig) => {
    setModalTitle('Success')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie
            animationData={successAnim}
            loop={false}
            style={{ width: 200, height: 200, margin: "0px" }}
        />
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          {isCopyConfig && (<Button icon="pi pi-chevron-right"  label='Go to new site' severity="success" onClick={() => HandleUipiodOnClick(newSiteUUID)}/>)}
          <br></br>
          {isCopyConfig && (<Button icon="pi pi-chevron-left" label='Go to original site' severity='info' onClick={() => HandleUipiodOnClick(dataManager.getItem('deviceUUIDToCopyFrom'))}/>)}
          <br></br>
          <Button icon="pi pi-times"  label='Close' onClick={HandleCloseModal} severity='secondary'/>
        </div>
      </div>
    )
    HandleShowModal();
  }

  const errorModal = (message, isCopyConfig) => {
    setModalTitle('Error')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
       <Lottie
            animationData={failAnim}
            loop={false}
            style={{ width: 150, height: 150, margin: "0px" }}
        />
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <Button icon="pi pi-times"  label='Close' severity='secondary' onClick={HandleCloseModal}/>
        </div>
      </div>
    )
    HandleShowModal();
  }

  const loadingModal = (message) => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
       <Lottie
            animationData={loadingAnim}
            loop={false}
            style={{ width: 200, height: 200, margin: "0px" }}
        />
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
        </div>
        <br></br>
        <br></br>
      </div>
    )
    HandleShowModal();
  }

  const handleCheckboxChange = (uuid, deviceID, deviceName) => {
    if (!dataManager.getItem('isAddAccessMode')) {
      setCheckedItems((prevCheckedItems) => {
        if (prevCheckedItems.includes(uuid)) {
          return prevCheckedItems.filter((id) => id !== uuid);
        } else {
          return [...prevCheckedItems, uuid];
        }
      });
    } else {
      setCheckedItems((prevCheckedItems) => {
        if (prevCheckedItems.some((item) => item.deviceID === deviceID)) {
          return prevCheckedItems.filter((item) => item.deviceID !== deviceID);
        } else {
          return [...prevCheckedItems, { deviceID, deviceName }];
        }
      });
    }
  };

  const HandleSitesChange = (deviceUUID, deviceID, deviceName) => {
    setSitesToRemove((prevSitesToRemove) => {
      // Check if the combination of deviceUUID and deviceID already exists
      const exists = prevSitesToRemove.some(
        (site) => site.deviceUUID === deviceUUID && site.deviceID === deviceID
      );

      if (exists) {
        // Remove the item if it already exists
        return prevSitesToRemove.filter(
          (site) => site.deviceUUID !== deviceUUID || site.deviceID !== deviceID
        );
      } else {
        // Add the item if it doesn't exist
        return [...prevSitesToRemove, { deviceUUID, deviceID }];
      }
    });
  }

  const HandleSitesForGroupChange = (uuid) => {
    setSitesForGroup((prevSitesForGroup) => {
      if (prevSitesForGroup.includes(uuid)) {
        return prevSitesForGroup.filter((id) => id !== uuid);
      } else {
        return [...prevSitesForGroup, uuid];
      }
    });

  }

  useEffect(() => {
    dataManager.setSelectedSites(checkedItems)
  }, [checkedItems])

  // const handleCopyUsersSelected = (event) => {
  //   setCopyUsersChecked(event.target.checked);
  //   dataManager.setItem('copyUsersChecked', event.target.checked);
  //   showCopySiteSettingsModal(deviceKey);
  // }

  // const handleSetPortalNameSelected = (event) => {
  //   dataManager.setItem('setPortalNameSelected', event.target.checked);
  //   showCopySiteSettingsModal(deviceKey);
  // }

  // const handleSetGroupSelected = (event) => {
  //   dataManager.setItem('setPortalGroupSelected', event.target.checked);
  //   showCopySiteSettingsModal(deviceKey);
  // }

  const HandleSiteChecked = (rowData) => {
    setCheckedSites(prevCheckedSites => {
      const exists = prevCheckedSites.some(site => site.id === rowData.id);
      if (exists) {
        return prevCheckedSites.filter(site => site.id !== rowData.id);
      } else {
        return [...prevCheckedSites, rowData];
      }
    });
  }

  const HandleSelectAllSites = () => {
    if (selectAllSites) {
      setSelectAllSites(false)
      setCheckedSites([])
    } else {
      setSelectAllSites(true)
      setCheckedSites(SiteDevices)
    }
  }

  const massActionOptions = [
    "Add users",
    "Reset sites",
    "Switch active status",
    "Suspend/Unsuspend sites",
    "Clear event logs",
    "Add sites to group",
    "Create permanent schedule",
    "Set site type",
    "Set site location"
  ]

  if (company == "EyeSpyFX" ) {
    massActionOptions.push("Set live view status")
    massActionOptions.push("Update billable")
    massActionOptions.push("Update billed to")
    massActionOptions.push("Update owned by")
    massActionOptions.push("Update billing frequency")
    massActionOptions.push("Update date of hardware invoice")
    massActionOptions.push("Update date of 1st SaaS invoice")
    massActionOptions.push("Update date made active")
  }

  if (company === "EyeSpyFX" || company === "RE:SURE") {
    massActionOptions.push("Update customer billed to")
  }

  const [filteredMassActionOptions, setFilteredMassActionOptions] = useState(massActionOptions);

  useEffect(() => {
    if (checkedSites.length > 0) {
      setShowMassSettings(true)
      const hasScheduleOnlySite = checkedSites.some(site => site.scheduleOnly === 1);
    
      setFilteredMassActionOptions(hasScheduleOnlySite
      ? massActionOptions.filter(opt => opt !== "Add users")
      : massActionOptions)
    } else {
      setShowMassSettings(false)
      setSelectedMassAction("")
    }
  }, [checkedSites])


  const HandleCamerasClick = (siteData) => {
    if (siteData.uuid) {
      dispatch(serviceActions.setDeviceUUID(siteData.uuid));
      navigate("/Dashboard/liveViewSites/Site/" + siteData.uuid, {
        state: siteData
      });
    }
    useSetCookie("SiteUUID", siteData.uuid, 1);
  }

  let tablecolumns = [
    {
      id: 'tag',
      meta: { exemptFromDim: true },
      header: () => (
        <div className={classes.tableTitleText}>
          {(!groupMode && !addAccessMode && showMassSelect && (role === "admin" || role === "TechSupport")) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                onChange={e => HandleSelectAllSites()}
                checked={selectAllSites}>
              </Checkbox>
            </div>
          )}
          <h3 style={{ marginLeft: "20px" }}>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !(columnVisibility['tag'] ?? true),
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag != "") {
          deviceName = row.row.original.tag
        }
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {((groupMode || addAccessMode) && (role === "admin" || role === "TechSupport")) && (
              <div style={{ marginRight: "10px", opacity: row.row.original.scheduleOnly === 1 ? 0.2 : 1 }}>
                {/* Added margin to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={row.row.original.scheduleOnly === 0 ? classes["circular-checkbox"] : classes["circular-checkbox-disabled"]}
                    style={{}}
                    checked={(checkedItems.some((item) => item === row.row.original.uuid)) ||
                      (checkedItems.some((item) => item.deviceID === row.row.original.id))
                    }
                    disabled={row.row.original.scheduleOnly === 1}
                    onChange={() => handleCheckboxChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={row.row.original.scheduleOnly === 0 ? classes['custom-checkbox'] : classes["custom-checkbox-disabled"]}
                  />
                </div>
              )}


              {(!groupMode && !addAccessMode && showMassSelect && (role === "admin" || role === "TechSupport")) && (
                <div style={{ marginRight: "10px" }}>
                  <Checkbox
                    onChange={e => HandleSiteChecked(row.row.original)}
                    checked={checkedSites.some((item) => item.id === row.row.original.id)}>
                  </Checkbox>
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
    {
      hidden: !(columnVisibility['deviceName'] ?? true),
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>{isUsersSites ? 'Their app site name' : 'App name'}</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <Link
            to={`/Dashboard/SiteView/${row.row.original.uuid}`}
            style={{
              display: 'block',
              maxWidth: '150px',
              overflow: 'hidden',
              whiteSpace: 'normal',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              textDecoration: 'none',
              color: 'inherit'
            }}
            className={classes.tableValueText}
          >
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </Link>
        );
      }
    },
    {
      hidden: !(columnVisibility['key'] ?? true),
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        // return (
        //   <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
        //     {row.row.original.key}
        //   </div>
        // )
        return (
          <Link
            to={`/Dashboard/SiteView/${row.row.original.uuid}`}
            className={classes.tableValueText}>
            {row.row.original.key}
          </Link>
        )
      }
    },
    {
      hidden: !(columnVisibility['serial'] ?? true),
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>S/N</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ip'] ?? true),
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        const scheduleOnly = row.row.original.scheduleOnly == 1
        let text = ""
        let colour = ""
        let textColour = ""
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.20.8") {
            text = "Davantis"
          }
        } else if (isTypeS) {
          text = "G2CC"
          colour = "#71e268"
          textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            
            <Pill_Widget_2
              pillColour={colour}
              textColour={textColour}
              text={text}
            />
            {scheduleOnly && <Pill_Widget_2
              pillColour="#e64c4c"
              textColour="#FFFFFF"
              text="S/O"
            />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['firmware'] ?? true),
      id: 'firmware',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>FW</h3>
        </div>
      ),
      filterLabel: "Firmware",
      accessorKey: 'firmware',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.firmware}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['status'] ?? true),
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['userCount'] ?? true),
      id: 'userCount',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Users</h3>
        </div>
      ),
      filterLabel: "User count",
      accessorKey: 'userCount',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.userCount}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['Devices'] ?? true),
      id: 'Devices',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Devices</h3>
        </div>
      ),
      filterLabel: "Devices",
      accessorKey: 'connectedDevices',
      cell: (row) => {
        const hasGateway = row.row.original.connectedDevices?.includes("Gateway")
        const hasAjax = row.row.original.connectedDevices?.includes("AJAX")
        const hasDahua = row.row.original.connectedDevices?.includes("DAHUA")
        const hasHik = row.row.original.connectedDevices?.includes("HIKVISION")
        const hasAibox = row.row.original.connectedDevices?.includes("AIBOX")
        const hasCamect = row.row.original.connectedDevices?.includes("CAMECT")
        const hasLiveView = row.row.original.liveViewEnabled == 1
        const cameraCount = row.row.original.cameraCount

        return (
          <div className={classes.tableValueTextBold}>
            {hasGateway == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={gateway_icon}></img>}
            {hasAjax == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={ajax_icon}></img>}
            {hasDahua == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={dahua_icon}></img>}
            {hasHik == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={hik_icon}></img>}
            {hasAibox == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={aibox_icon}></img>}
            {hasCamect == true && <img style={{ height: "18px", width: "18px", marginRight: "5px" }} src={camect_icon}></img>}
            {hasLiveView && (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  style={{ height: "18px", width: "18px" }}
                  src={live_view_icon}
                  alt="Live View"
                />
                <span
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                    background: cameraCount > 0 ? "#22ca80" : "#eb494eff",
                    color: "white",
                    borderRadius: "50%",
                    padding: "1px 5px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    lineHeight: 1,
                  }}
                >
                  {cameraCount}
                </span>
              </div>
            )}

          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['states'] ?? true),
      id: 'states',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>States</h3>
        </div>
      ),
      filterLabel: "States",
      cell: (row) => {
        const data = parsedData[row.row.index]
        const livePinStates = pinStatesByUUID[row.row.original.uuid]

        let OutputPins = data.OutputPins;
        let InputPins = data.InputPins;

        if (livePinStates) {
          const [liveOutputStates, liveInputStates] = livePinStates;

          OutputPins = OutputPins.map((output) => {
            const liveState = liveOutputStates.find((p) => p.pin === output.Pin);
            return liveState ? { ...output, pinState: liveState.pinState } : output;
          });

          InputPins = InputPins.map((input) => {
            const liveState = liveInputStates.find((p) => p.pin === input.Pin);
            return liveState ? { ...input, pinState: liveState.pinState } : input;
          });
        }

        return (
          <div className={classes["bottom-wrapper"]}>
            <div>
              <ul className={classes.outputs}>
                <OutputPinCircle OutputPins={OutputPins} />
              </ul>
            </div>
            <div className={classes["bottom-wrapper_divider"]} />
            <div>
              <ul className={classes.inputs}>
                <InputPinCircle InputPins={InputPins} />
              </ul>
            </div>
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteType'] ?? false),
      id: 'siteType',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site type</h3>
        </div>
      ),
      filterLabel: "Site type",
      accessorKey: 'site_type',
      cell: (row) => {
        const siteType = row.row.original.site_type;
        const label = siteTypeOptions.find(o => o.key === siteType)?.label || siteType || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteLocation'] ?? false),
      id: 'siteLocation',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site location</h3>
        </div>
      ),
      filterLabel: "Site location",
      accessorKey: 'country_code',
      cell: (row) => {
        const countryCode = row.row.original.country_code;
        const label = countryCodeOptions.find(c => c.code === countryCode)?.name || countryCode || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['group'] ?? true),
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    },
    
    {
      hidden: !(columnVisibility['ownedByGID'] ?? false),
      id: 'ownedByGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Site owner</h3>
            </div> 
        ),
        accessorKey: 'ownedByGID',
        filterLabel: "Site owner",
         cell: (row) => {
        const gid = row.row.original.ownedByGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billable'] ?? false),
      id: 'billable',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billable</h3>
            </div> 
        ),
        accessorKey: 'billable',
        filterLabel: "Billable",
        cell: (row) => {
            return (
                <div className={classes.tableValueText}>
                    <Pill_Widget
                    boolean={row.row.original.billable == 1}
                    PillColor_IfTrue={"#73cf72"}
                    PillColor_IfFalse={row.row.original.billable == 2 ? "#f0a500" : "#dc7277"}
                    text_IfTrue={"Yes"}
                    text_IfFalse={row.row.original.billable == 2 ? "Demo" : "No"}
                    className={classes.PillHeight} />
                </div>
            )
        }
    },
    {
      hidden: !(columnVisibility['billedToGID'] ?? false),
      id: 'billedToGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billed to</h3>
            </div> 
        ),
        accessorKey: 'billedToGID',
        filterLabel: "Billed to",
         cell: (row) => {
        const gid = row.row.original.billedToGID;
        if (row.row.original.billable != 1) return null;
        if (!gid) {
          if (row.row.original.billable == 1) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="pi pi-exclamation-triangle" style={{ color: '#dc7277', fontSize: '14px' }} />
                <Pill_Widget
                  boolean={false}
                  PillColor_IfTrue={"#73cf72"}
                  PillColor_IfFalse={"#dc7277"}
                  text_IfFalse={"Needs set"}
                  className={classes.PillHeight}
                />
              </div>
            );
          }
          return null;
        }
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
        {
      hidden: !(columnVisibility['customerBilledToGID'] ?? false),
      id: 'customerBilledToGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Customer billed to</h3>
            </div> 
        ),
        accessorKey: 'customerBilledToGID',
        filterLabel: "Customer billed to",
        cell: (row) => {
        const gid = row.row.original.customerBilledToGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billingFrequency'] ?? false),
      id: 'billingFrequency',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billing frequency</h3>
            </div> 
        ),
        accessorKey: 'billingFrequency',
        filterLabel: "Billing frequency",
        cell: (row) => {
            return (
                <div className={classes.tableValueTextBold}>
                  {row.row.original.billable == 1 ? (row.row.original.billingFrequency ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />) : null}
                </div>
            )
        }
    },
    {
      hidden: !(columnVisibility['dateOfSale'] ?? false),
      id: 'dateOfSale',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Date of hardware invoice</h3>
            </div> 
        ),
        accessorKey: 'firstInvoiceDate',
        filterLabel: "Date of hardware invoice",
        cell: (row) => {
            return (
                <div className={classes.tableValueTextBold}>
                  {UseDateFormat(row.row.original.firstInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />}
                </div>
            )
        }
    },
    {
      hidden: !(columnVisibility['recentInvoice'] ?? false),
      id: 'recentInvoice',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Date of 1st SaaS invoice</h3>
            </div> 
        ),
        accessorKey: 'lastInvoiceDate',
        filterLabel: "Date of 1st SaaS invoice",
        cell: (row) => {
            return (
                <div className={classes.tableValueTextBold}>
                  {row.row.original.billable == 1 ? (UseDateFormat(row.row.original.lastInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />) : null}
                </div>
            )
        }
    },
    
    {
      hidden: !(columnVisibility['active'] ?? true),
      id: 'active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
            <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)} disabled={role !== "admin" && role !== "TechSupport"} style={(role !== "admin" && role !== "TechSupport") ? { opacity: 0.5 } : undefined} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['dateMadeActive'] ?? false),
      id: 'dateMadeActive',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Site active since</h3>
            </div> 
        ),
        accessorKey: 'dateMadeActive',
        filterLabel: "Site active since",
        cell: (row) => {
            return (
                <div className={classes.tableValueTextBold}>
                  {row.row.original.active == "1" ? (UseDateFormat(row.row.original.dateMadeActive) ?? null) : null}
                </div>
            )
        }
    },
    {
      hidden: !(columnVisibility['actions'] ?? true),
      id: 'actions',
      meta: { exemptFromDim: true },
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: ChangeSerialIcon,
            title: "Change serial number",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        // if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
        //   items.splice(4, 0, {
        //     image: CamectIntegrationIcon,
        //     title: "Change camect integration type",
        //   },);
        // }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && (DeviceType != "CC" && DeviceType != 'S')) {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        if (role !== "admin" && role !== "TechSupport") return null;
        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";

        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              row.row.original.subGroup
            )
          }
          listItems={items}
        />
      },
    }
  ];

  let tablecolumnsLiveViewOnly = [
    {
      id: 'tag',
      meta: { exemptFromDim: true },
      header: () => (
        <div className={classes.tableTitleText}>
          {(!groupMode && !addAccessMode && showMassSelect && (role === "admin" || role === "TechSupport")) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                onChange={e => HandleSelectAllSites()}
                checked={selectAllSites}>
              </Checkbox>
            </div>
          )}
          <h3 style={{ marginLeft: "20px" }}>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !(columnVisibility['tag'] ?? true),
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {((groupMode || addAccessMode) && (role === "admin" || role === "TechSupport")) && (
                <div style={{ marginRight: "10px" }}>  {/* Added margin to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={(checkedItems.some((item) => item === row.row.original.uuid)) ||
                      (checkedItems.some((item) => item.deviceID === row.row.original.id))
                    }

                    onChange={() => handleCheckboxChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}


              {(!groupMode && !addAccessMode && showMassSelect && (role === "admin" || role === "TechSupport")) && (
                <div style={{ marginRight: "10px" }}>
                  <Checkbox
                    onChange={e => HandleSiteChecked(row.row.original)}
                    checked={checkedSites.some((item) => item.id === row.row.original.id)}>
                  </Checkbox>
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },

    {
      hidden: !(columnVisibility['key'] ?? true),
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        // return (
        //   <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
        //     {row.row.original.key}
        //   </div>
        // )
        return (
          <Link
            to={`/Dashboard/SiteView/${row.row.original.uuid}`}
            className={classes.tableValueText}>
            {row.row.original.key}
          </Link>
        )
      }
    },
    {
      hidden: !(columnVisibility['linked'] ?? true),
      id: 'linked',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Camera count</h3>
        </div>
      ),
      filterLabel: "cameraCount",
      accessorKey: 'cameraCount',
      cell: (row) => {
        const hasCameras = row.row.original.cameraCount > 0 ? true : false
        return (
          <div onClick={() => HandleCamerasClick(row.row.original)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={hasCameras}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={row.row.original.cameraCount}
              text_IfFalse={"0"}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },

    {
      hidden: !(columnVisibility['serial'] ?? true),
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>S/N</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ip'] ?? true),
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        const scheduleOnly = row.row.original.scheduleOnly == 1
        let text = ""
        let colour = ""
        let textColour = ""
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.20.8") {
            text = "Davantis"
          }
        } else if (isTypeS) {
          text = "G2CC"
          colour = "#71e268"
          textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget_2
              pillColour={colour}
              textColour={textColour}
              text={text}
            />
            {scheduleOnly && <Pill_Widget_2
              pillColour="#e64c4c"
              textColour="#FFFFFF"
              text="S/O"
            />}
          </div>
        )
      }
    },

    {
      hidden: !(columnVisibility['status'] ?? true),
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteType'] ?? false),
      id: 'siteType',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site type</h3>
        </div>
      ),
      filterLabel: "Site type",
      accessorKey: 'site_type',
      cell: (row) => {
        const siteType = row.row.original.site_type;
        const label = siteTypeOptions.find(o => o.key === siteType)?.label || siteType || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteLocation'] ?? false),
      id: 'siteLocation',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site location</h3>
        </div>
      ),
      filterLabel: "Site location",
      accessorKey: 'country_code',
      cell: (row) => {
        const countryCode = row.row.original.country_code;
        const label = countryCodeOptions.find(c => c.code === countryCode)?.name || countryCode || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },

    {
      hidden: !(columnVisibility['group'] ?? true),
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    },
    {
      hidden: !(columnVisibility['customerBilledToGID'] ?? false),
      id: 'customerBilledToGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Customer billed to</h3>
            </div> 
        ),
        accessorKey: 'customerBilledToGID',
        filterLabel: "Customer billed to",
        cell: (row) => {
        const gid = row.row.original.customerBilledToGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['active'] ?? true),
      id: 'active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
            <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)} disabled={role !== "admin" && role !== "TechSupport"} style={(role !== "admin" && role !== "TechSupport") ? { opacity: 0.5 } : undefined} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['actions'] ?? true),
      id: 'actions',
      meta: { exemptFromDim: true },
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: ChangeSerialIcon,
            title: "Change serial number",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        // if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
        //   items.splice(4, 0, {
        //     image: CamectIntegrationIcon,
        //     title: "Change camect integration type",
        //   },);
        // }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && DeviceType != "CC") {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        if (role !== "admin" && role !== "TechSupport") return null;
        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";

        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              row.row.original.subGroup
            )
          }
          listItems={items}
        />
      },
    }
  ];

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups.find(g => g.name === groupName);

    if (groupClicked) {
      sessionStorage.setItem('groupClicked', groupClicked.name)
      sessionStorage.setItem('groupPath', groupClicked.group_path)
      sessionStorage.setItem('groupClickedID', groupClicked.id)
      navigate("/Dashboard/Groups/GroupSites")
    }
  }

  let tableColumnsOfflineOnly = [
    {
      id: 'tag',
      meta: { exemptFromDim: true },
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Portal name ⇅</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !(columnVisibility['tag'] ?? true),
      cell: (row) => {
        const uuid = row.row.original.uuid;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {groupMode || addAccessMode && (
              <div style={{ marginLeft: "10px", marginTop: "3px", marginRight: "20px" }}>
                <input
                  type="checkbox"
                  id={`checkbox-${uuid}`}
                  className={classes["circular-checkbox"]}
                  checked={checkedItems.some((item) => item === row.row.original.uuid)}
                  onChange={() => handleCheckboxChange(uuid)}
                />
                <label
                  htmlFor={`checkbox-${uuid}`}
                  className={classes['custom-checkbox']}
                />
              </div>
            )}
            <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
              {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                <Pill_Widget
                  boolean={true}
                  PillColor_IfTrue={"#919191"}
                  PillColor_IfFalse={"#6e6e6e"}
                  text_IfTrue={row.row.original.tag}
                  className={classes.PillHeight}
                />
              )}
            </div>
          </div>
        );
      },
    },
    {
      hidden: !(columnVisibility['deviceName'] ?? true),
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>{isUsersSites ? 'Their app site name ⇅' : 'My app site name ⇅'}</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['key'] ?? true),
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site ID ⇅</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {

        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.key}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['offlineSince'] ?? true),
      id: 'offlineSince',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Offline since ⇅</h3>
        </div>
      ),
      filterLabel: "Offline Since",
      accessorKey: 'lastLoggedIn',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              PillColor_IfTrue={"#ff4f70"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={UseDateFormat(row.row.original.lastLoggedIn)}
              text_IfFalse={UseDateFormat(row.row.original.lastLoggedIn)}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['serial'] ?? true),
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Serial number ⇅</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ip'] ?? true),
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>IP address ⇅</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={isCC}
              PillColor_IfTrue={"#6996f1"}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={"IPIO CC"}
              text_IfFalse={row.row.original.ip}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['firmware'] ?? true),
      id: 'firmware',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Firmware ⇅</h3>
        </div>
      ),
      filterLabel: "Firmware",
      accessorKey: 'firmware',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.firmware}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['userCount'] ?? true),
      id: 'userCount',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Users ⇅</h3>
        </div>
      ),
      filterLabel: "User count",
      accessorKey: 'userCount',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.userCount}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteType'] ?? false),
      id: 'siteType',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site type</h3>
        </div>
      ),
      filterLabel: "Site type",
      accessorKey: 'site_type',
      cell: (row) => {
        const siteType = row.row.original.site_type;
        const label = siteTypeOptions.find(o => o.key === siteType)?.label || siteType || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteLocation'] ?? false),
      id: 'siteLocation',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site location</h3>
        </div>
      ),
      filterLabel: "Site location",
      accessorKey: 'country_code',
      cell: (row) => {
        const countryCode = row.row.original.country_code;
        const label = countryCodeOptions.find(c => c.code === countryCode)?.name || countryCode || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['group'] ?? true),
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Group ⇅</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;
        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div onClick={() => HandleGroupOnClick(row.row.original.name)} style={{ cursor: "pointer", width: "fit-content", color: "white", fontWeight: "600" }}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ownedByGID'] ?? false),
      id: 'ownedByGID',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site owner</h3>
        </div>
      ),
      accessorKey: 'ownedByGID',
      filterLabel: "Site owner",
      cell: (row) => {
        const gid = row.row.original.ownedByGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billable'] ?? false),
      id: 'billable',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billable</h3>
        </div>
      ),
      accessorKey: 'billable',
      filterLabel: "Billable",
      cell: (row) => {
        return (
          <div className={classes.tableValueText}>
            <Pill_Widget
              boolean={row.row.original.billable == 1}
              PillColor_IfTrue={"#73cf72"}
              PillColor_IfFalse={"#dc7277"}
              text_IfTrue={"Yes"}
              text_IfFalse={"No"}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billedToGID'] ?? false),
      id: 'billedToGID',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billed to</h3>
        </div>
      ),
      accessorKey: 'billedToGID',
      filterLabel: "Billed to",
      cell: (row) => {
        const gid = row.row.original.billedToGID;
        if (row.row.original.billable != 1) return null;
        if (!gid) {
          if (row.row.original.billable == 1) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="pi pi-exclamation-triangle" style={{ color: '#dc7277', fontSize: '14px' }} />
                <Pill_Widget
                  boolean={false}
                  PillColor_IfTrue={"#73cf72"}
                  PillColor_IfFalse={"#dc7277"}
                  text_IfFalse={"Needs set"}
                  className={classes.PillHeight}
                />
              </div>
            );
          }
          return null;
        }
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['customerBilledToGID'] ?? false),
      id: 'customerBilledToGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Customer billed to</h3>
            </div> 
        ),
        accessorKey: 'customerBilledToGID',
        filterLabel: "Customer billed to",
        cell: (row) => {
        const gid = row.row.original.customerBilledToGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billingFrequency'] ?? false),
      id: 'billingFrequency',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billing frequency</h3>
        </div>
      ),
      accessorKey: 'billingFrequency',
      filterLabel: "Billing frequency",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {row.row.original.billable == 1 ? (row.row.original.billingFrequency ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />) : null}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['dateOfSale'] ?? false),
      id: 'dateOfSale',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Date of sale</h3>
        </div>
      ),
      accessorKey: 'firstInvoiceDate',
      filterLabel: "Date of sale",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {UseDateFormat(row.row.original.firstInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['recentInvoice'] ?? false),
      id: 'recentInvoice',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Last invoiced</h3>
        </div>
      ),
      accessorKey: 'lastInvoiceDate',
      filterLabel: "Last invoiced",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {UseDateFormat(row.row.original.lastInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['active'] ?? true),
      id: 'active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
            <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)} disabled={role !== "admin" && role !== "TechSupport"} style={(role !== "admin" && role !== "TechSupport") ? { opacity: 0.5 } : undefined} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['dateMadeActive'] ?? false),
      id: 'dateMadeActive',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site active since</h3>
        </div>
      ),
      accessorKey: 'dateMadeActive',
      filterLabel: "Site active since",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {row.row.original.active == "1" ? (UseDateFormat(row.row.original.dateMadeActive) ?? null) : null}
          </div>
        )
      }
    },
  ];

  let tableColumnsUserSites = [
    {
      id: 'tag',
      meta: { exemptFromDim: true },
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      hidden: !(columnVisibility['tag'] ?? true),
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const deviceID = row.row.original.id;
        let deviceName = row.row.original.key;

        if (row.row.original.deviceName !== "") {
          deviceName = row.row.original.deviceName
        }

        if (row.row.original.tag !== "") {
          deviceName = row.row.original.tag
        }
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {(editUserAccess && !sitesForGroupMode && (role === "admin" || role === "TechSupport")) && (
                <div style={{ marginRight: "10px" }}>  {/* Added marginRight to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={sitesToRemove.some(
                      (item) => item.deviceUUID === row.row.original.uuid && item.deviceID === row.row.original.deviceID
                    )}
                    onChange={() => HandleSitesChange(uuid, deviceID, deviceName)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}

              {(!editUserAccess && sitesForGroupMode && (role === "admin" || role === "TechSupport")) && (
                <div style={{ marginRight: "10px" }}>  {/* Added marginRight to separate from the pill */}
                  <input
                    type="checkbox"
                    id={`checkbox-${uuid}`}
                    className={classes["circular-checkbox"]}
                    checked={sitesForGroup.some(
                      (item) => item === row.row.original.uuid
                    )}
                    onChange={() => HandleSitesForGroupChange(uuid)}
                  />
                  <label
                    htmlFor={`checkbox-${uuid}`}
                    className={classes['custom-checkbox']}
                  />
                </div>
              )}

              <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
            </div>
          </div>

        );
      },
    },
    {
      hidden: !(columnVisibility['deviceName'] ?? true),
      id: 'deviceName',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Their app site name</h3>
        </div>
      ),
      filterLabel: "My site name",
      accessorKey: 'deviceName',
      cell: (row) => {
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }} onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
              <Pill_Widget
                boolean={true}
                PillColor_IfTrue={"#C3B1E1"}
                PillColor_IfFalse={"#6e6e6e"}
                text_IfTrue={row.row.original.deviceName}
                className={classes.PillHeight}
              />
            )}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['key'] ?? true),
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.key}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['serial'] ?? true),
      id: 'serial',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Serial number</h3>
        </div>
      ),
      filterLabel: "Serial number",
      accessorKey: 'subGroup',
      cell: (row) => {
        const subGroup = row.row.original.subGroup;
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {subGroup != "" ? subGroup : "-"}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ip'] ?? true),
      id: 'ip',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>IP/Site Type</h3>
        </div>
      ),
      filterLabel: "IP address",
      accessorKey: 'ip',
      cell: (row) => {
        const isCC = row.row.original.type === "CC" ? true : false
        const isTypeS = row.row.original.type === "S" ? true : false
        const ipAddress = row.row.original.ip
        const scheduleOnly = row.row.original.scheduleOnly == 1
        let text = ""
        let colour = ""
        let textColour = ""
        if (isCC) {
          colour = "#6996f1"
          textColour = "#ffffffff"
          if (ipAddress == "10.250.20.173") {
            text = "CC Server 1"
          } else if (ipAddress == "10.250.20.155") {
            text = "CC Server 2"
          } else if (ipAddress == "10.250.20.175") {
            text = "CC Server 3"
          } else if (ipAddress == "10.250.20.165") {
            text = "CC Server 4"
          } else if (ipAddress == "10.250.20.224") {
            text = "CC Server 5"
          } else if (ipAddress == "10.250.20.98") {
            text = "CC Server 6"
          } else if (ipAddress == "10.250.20.184") {
            text = "CC Server 7"
          } else if (ipAddress == "10.250.20.130") {
            text = "CC Server 8"
          } else if (ipAddress == "10.250.20.21") {
            text = "CC Server 9"
          } else if (ipAddress == "10.250.1.22") {
            text = "Upgrade Server"
          } else if (ipAddress == "10.250.1.64") {
            text = "FW Dev Server"
          } else if (ipAddress == "10.250.20.178") {
            text = "CC Server 10"
          } else if (ipAddress == "10.250.20.8") {
            text = "Davantis"
          }
        } else if (isTypeS) {
          text = "G2CC"
          colour = "#71e268"
          textColour = "#2f2f2f"
        } else {
          colour = "#626a67"
          textColour = "#ffffffff"
          text = ipAddress
        }
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget_2
              pillColour={colour}
              textColour={textColour}
              text={text}
            />
            {scheduleOnly && <Pill_Widget_2
              pillColour="#e64c4c"
              textColour="#FFFFFF"
              text="S/O"
            />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['role'] ?? true),
      id: 'role',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Role</h3>
        </div>
      ),
      filterLabel: "role",
      accessorKey: 'role',
      cell: (row) => {
        let newRole;
        switch (row.row.original.role) {
          case 'user':
            newRole = "App standard user"
            break;
          case 'manager':
            newRole = "App manager"
            if (row.row.original.liveViewAccess == 1) {
              newRole = "Manager Plus"
            }
        }
        const setPillColour = row.row.original.role == 'user' ? true : false
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={setPillColour}
              PillColor_IfTrue={"#9c9c9c"}
              PillColor_IfFalse={"#1e82d4"}
              text_IfTrue={newRole}
              text_IfFalse={newRole}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['invitedBy'] ?? true),
      id: 'invitedBy',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Invited by</h3>
        </div>
      ),
      filterLabel: "invitedby",
      accessorKey: 'invitedByName',
      cell: (row) => {

        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
            {row.row.original.invitedByName}
          </div>
        )

      }
    },
    {
      hidden: !(columnVisibility['status'] ?? true),
      id: 'status',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Status</h3>
        </div>
      ),
      filterLabel: "Status",
      accessorKey: 'status',
      cell: (row) => {
        const OnlineStatus = row.row.original.online == "YES" ? true : false
        const SuspendedStatus = row.row.original.status == "suspended";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            <Pill_Widget
              boolean={OnlineStatus}
              PillColor_IfTrue={"#22ca80"}
              PillColor_IfFalse={"#ff4f70"}
              text_IfTrue={"Online"}
              text_IfFalse={"Offline"}
              className={classes.PillHeight}
            />

            {SuspendedStatus &&
              <Pill_Widget
                boolean={SuspendedStatus}
                PillColor_IfTrue={"black"}
                PillColor_IfFalse={"none"}
                text_IfTrue={"Suspended"}
                className={classes.PillHeight}
              />
            }
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteType'] ?? false),
      id: 'siteType',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site type</h3>
        </div>
      ),
      filterLabel: "Site type",
      accessorKey: 'site_type',
      cell: (row) => {
        const siteType = row.row.original.site_type;
        const label = siteTypeOptions.find(o => o.key === siteType)?.label || siteType || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['siteLocation'] ?? false),
      id: 'siteLocation',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site location</h3>
        </div>
      ),
      filterLabel: "Site location",
      accessorKey: 'country_code',
      cell: (row) => {
        const countryCode = row.row.original.country_code;
        const label = countryCodeOptions.find(c => c.code === countryCode)?.name || countryCode || "-";
        return (
          <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
            {label}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['group'] ?? true),
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;
        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['ownedByGID'] ?? false),
      id: 'ownedByGID',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site owner</h3>
        </div>
      ),
      accessorKey: 'ownedByGID',
      filterLabel: "Site owner",
      cell: (row) => {
        const gid = row.row.original.ownedByGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billable'] ?? false),
      id: 'billable',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billable</h3>
        </div>
      ),
      accessorKey: 'billable',
      filterLabel: "Billable",
      cell: (row) => {
        return (
          <div className={classes.tableValueText}>
            <Pill_Widget
              boolean={row.row.original.billable == 1}
              PillColor_IfTrue={"#73cf72"}
              PillColor_IfFalse={"#dc7277"}
              text_IfTrue={"Yes"}
              text_IfFalse={"No"}
              className={classes.PillHeight} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billedToGID'] ?? false),
      id: 'billedToGID',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billed to</h3>
        </div>
      ),
      accessorKey: 'billedToGID',
      filterLabel: "Billed to",
      cell: (row) => {
        const gid = row.row.original.billedToGID;
        if (row.row.original.billable != 1) return null;
        if (!gid) {
          if (row.row.original.billable == 1) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="pi pi-exclamation-triangle" style={{ color: '#dc7277', fontSize: '14px' }} />
                <Pill_Widget
                  boolean={false}
                  PillColor_IfTrue={"#73cf72"}
                  PillColor_IfFalse={"#dc7277"}
                  text_IfFalse={"Needs set"}
                  className={classes.PillHeight}
                />
              </div>
            );
          }
          return null;
        }
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['customerBilledToGID'] ?? false),
      id: 'customerBilledToGID',
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Customer billed to</h3>
            </div> 
        ),
        accessorKey: 'customerBilledToGID',
        filterLabel: "Customer billed to",
        cell: (row) => {
        const gid = row.row.original.customerBilledToGID;
        if (!gid) return null;
        let companyName = groups.find(g => g.id == gid)?.name ?? String(gid);

        if (loggedInAs == companyName) {
          return;
        }

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '100px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(companyName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={companyName}
              className={classes.PillHeight}
            />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['billingFrequency'] ?? false),
      id: 'billingFrequency',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Billing frequency</h3>
        </div>
      ),
      accessorKey: 'billingFrequency',
      filterLabel: "Billing frequency",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {row.row.original.billable == 1 ? (row.row.original.billingFrequency ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />) : null}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['dateOfSale'] ?? false),
      id: 'dateOfSale',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Date of sale</h3>
        </div>
      ),
      accessorKey: 'firstInvoiceDate',
      filterLabel: "Date of sale",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {UseDateFormat(row.row.original.firstInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['recentInvoice'] ?? false),
      id: 'recentInvoice',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Last invoiced</h3>
        </div>
      ),
      accessorKey: 'lastInvoiceDate',
      filterLabel: "Last invoiced",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {UseDateFormat(row.row.original.lastInvoiceDate) ?? <Pill_Widget boolean={false} PillColor_IfFalse={"#dc7277"} text_IfFalse={"Not set"} className={classes.PillHeight} />}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['dateMadeActive'] ?? false),
      id: 'dateMadeActive',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site active since</h3>
        </div>
      ),
      accessorKey: 'dateMadeActive',
      filterLabel: "Site active since",
      cell: (row) => {
        return (
          <div className={classes.tableValueTextBold}>
            {row.row.original.active == "1" ? (UseDateFormat(row.row.original.dateMadeActive) ?? null) : null}
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['active'] ?? true),
      id: 'active',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Active</h3>
        </div>
      ),
      filterLabel: "Active",
      accessorKey: 'active',
      cell: (row) => {
        const active = row.row.original.active == "1" ? true : false
        return (
          <div className={classes.tableValueText}>
            <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)} disabled={role !== "admin" && role !== "TechSupport"} style={(role !== "admin" && role !== "TechSupport") ? { opacity: 0.5 } : undefined} />
          </div>
        )
      }
    },
    {
      hidden: !(columnVisibility['actions'] ?? true),
      id: 'actions',
      meta: { exemptFromDim: true },
      filterLabel: "Settings",
      cell: (row) => {
        let items = [
          {
            image: revokeAccess,
            title: "Revoke access"
          },
          {
            image: ChangeRole,
            title: "Change role"
          },
          { divider: true },
          {
            image: SuspendIcon,
            title:
              row.row.original.status !== "suspended"
                ? "Suspend Site"
                : "Unsuspend Site",
          },
          {
            image: ClearLogsIcon,
            title: "Clear Logs",
          },
          {
            image: ChangePortalNameIcon,
            title: "Change portal name",
          },
          {
            image: AddToGroupIcon,
            title: "Add to group"
          }
        ];

        const firmware = row.row.original.firmware.split('.')
        const firmwareMajor = firmware[0]
        const firmwareMinor = firmware[1]
        const DeviceType = row.row.original.type;
        const isOnline = row.row.original.online == "YES" ? true : false;

        const deviceDetails = JSON.parse(row.row.original.deviceDetails);
        const camectIntegationType = deviceDetails.camectIntegrationType;

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 9)) && DeviceType != 'V') {
          items.splice(4, 0, {
            image: CamectIntegrationIcon,
            title: "Change camect integration type",
          },);
        }

        if ((firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7))) {
          items.splice(5, 0, {
            image: CopyConfigIcon,
            title: "Copy site configuration",
          });
        }

        if (isOnline && DeviceType != "CC") {
          items.splice(6, 0, {
            image: RebootIcon,
            title: "Reboot site",
          })
        }

        if (isOnline) {
          items.splice(7, 0,
            {
              image: ResetIcon,
              title: "Reset site",
            });
        }

        if (role !== "admin" && role !== "TechSupport") return null;
        const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
        const suspend = row.row.original.status == "suspended" ? "available" : "suspended";
        return <DropdownList
          item={row.row.id}
          icon={SettingsCog}
          onClick={handleSettingsClick}
          ifSettingsCogIsClicked={ifSettingsCogIsClicked}
          ref={dropdownRef}
          title={"Actions"}
          className={classes.container}
          onUserActionClick={(userAction) =>
            UserActionHandler(
              userAction,
              suspend,
              row.row.original.id,
              row.row.original.uuid,
              userID,
              row.row.original.name,
              row.row.original.key,
              camectIntegationType,
              row.row.original.tag,
              row.row.original,
              deviceDetails,
              row.row.original.type,
              1
            )
          }
          listItems={items}
        />
      },
    }
  ]

  if (offlineOnly) {
    tablecolumns = tableColumnsOfflineOnly
  }
  if (isUsersSites) {
    tablecolumns = tableColumnsUserSites
  }
  if (liveViewOnly) {
    tablecolumns = tablecolumnsLiveViewOnly
  }

  const sortedTablecolumns = columnOrder.length
    ? [...tablecolumns].sort((a, b) => {
        const ai = columnOrder.indexOf(a.id);
        const bi = columnOrder.indexOf(b.id);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      })
    : tablecolumns;
  const tableColumnsFiltered = sortedTablecolumns.filter(column => !column.hidden);
  let tableData = SiteDevices;

  useEffect(() => {
    if (selectAllCancelled) {
      setSelectAll(false)
    }
  }, [selectAllCancelled])

  const HandleSelectAll = () => {
    if (selectAll == null || !selectAll) {
      setSelectAll(true)
      setShowMassSettings(true)
    } else if (selectAll) {
      setSelectAll(false)
      setShowMassSettings(false)
    }
  }

  const ShowActionCompleteModal = (passCount, failCount, action) => {
    setCheckedSites([])
    setSelectedMassAction("")
    dataManager.setItem('selectedGroup', "")
    setModalTitle("Complete")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Successfully {action} {passCount} sites</h3>
        {(failCount > 0) && (<h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failCount} sites failed to {action}</h3>)}
      </div>
    )
  }

  const showLoadingModal = () => {
    setModalTitle('Please wait...')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie animationData={loadingAnim} loop={true} style={{ width: 250, height: 250, margin: "0px" }} />
        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Performing action, please wait...</h3>
      </div>
    )
    HandleShowModal();
  }

  const UpdateSiteDetails = async (uuid, columnName, newValue) => {
    const body = {
      siteUUID: uuid,
      columnName: columnName,
      newValue: newValue
    }
    const response = await updateSiteDetails(apiData, body, dispatch)
    return response
  }

  const updateAndNotifySites = (successfulUUIDs, columnName, newValue, message) => {
    setSiteDevices(prev =>
      prev.map(site =>
        successfulUUIDs.includes(site.uuid)
          ? { ...site, [columnName]: newValue }
          : site
      )
    )
    const allSuccessful = successfulUUIDs.length === checkedSites.length
    if (allSuccessful) {
      successModal(message, false)
    } else {
      errorModal("Some updates failed, please try again", false)
    }
  }

  const massUpdateSitesBillable = async (newStatus) => {
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'billable', newStatus)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "billable", newStatus, "Billing status updated")
  }

  const massUpdateSitesBilledTo = async (value) => {
    const groupObj = groups.find(g => g.name === value)
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'billedToGID', groupObj.id)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "billedToGID", groupObj.id, "Billed to updated")
  }

  const massUpdateSitesCustomerBilledTo = async (value) => {
    const groupObj = groups.find(g => g.name === value)
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'customerBilledToGID', groupObj.id)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "customerBilledToGID", groupObj.id, "Customer billed to updated")
  }

  const massUpdateSitesOwnedBy = async (value) => {
    const groupObj = groups.find(g => g.name === value)
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'ownedByGID', groupObj.id)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "ownedByGID", groupObj.id, "Owner updated")
  }

  const billingOptions = ["Monthly", "Annually"]

  const massUpdateSitesBillingFrequency = async () => {
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'billingFrequency', newBillingFrequency)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "billingFrequency", newBillingFrequency, "Billing frequency updated")
    setShowBillingFrequencyDialog(false)
    setNewBillingFrequency(null)
  }

  const massUpdateSitesDateOfSale = async () => {
    const formattedDate = newDateOfSale ? format(newDateOfSale, "yyyy-MM-dd") : ""
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'firstInvoiceDate', formattedDate)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "firstInvoiceDate", formattedDate, "Date of sale updated")
    setShowDateOfSaleDialog(false)
    setNewDateOfSale(null)
  }

  const massUpdateSitesInvoiceDate = async () => {
    const formattedDate = newInvoiceDate ? format(newInvoiceDate, "yyyy-MM-dd") : ""
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'lastInvoiceDate', formattedDate)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "lastInvoiceDate", formattedDate, "Invoice date updated")
    setShowInvoiceDateDialog(false)
    setNewInvoiceDate(null)
  }

  const massUpdateSitesDateMadeActive = async () => {
    const formattedDate = newDateMadeActive ? format(newDateMadeActive, "yyyy-MM-dd") : ""
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'dateMadeActive', formattedDate)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "dateMadeActive", formattedDate, "Date made active updated")
    setShowDateMadeActiveDialog(false)
    setNewDateMadeActive(null)
  }

  // Mirrors the single-site "Site type" / "Site location" editors in Overview.js, which write
  // to the same site_type / country_code columns via updateSiteDetails.
  const siteTypeOptions = [
    { key: 'RESIDENTIAL', label: 'Residential' },
    { key: 'OFFICE', label: 'Office' },
    { key: 'COMMERCIAL', label: 'Commercial' },
    { key: 'INDUSTRIAL', label: 'Industrial' },
    { key: 'CONSTRUCTION', label: 'Construction' },
    { key: 'WAREHOUSE', label: 'Warehouse / Storage' },
    { key: 'EDUCATION', label: 'Education' },
    { key: 'HEALTHCARE', label: 'Healthcare' },
    { key: 'PUBLIC', label: 'Public / Government' },
    { key: 'VACANT', label: 'Vacant property' },
    { key: 'UTILITY', label: 'Utility / Infrastructure' },
    { key: 'OTHER', label: 'Other' }
  ];

  const countryCodeOptions = [
    { code: 'GB', name: 'United Kingdom' },
    { code: 'IE', name: 'Ireland' },
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BR', name: 'Brazil' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CO', name: 'Colombia' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'EE', name: 'Estonia' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'GR', name: 'Greece' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JP', name: 'Japan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MT', name: 'Malta' },
    { code: 'MX', name: 'Mexico' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NO', name: 'Norway' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'RO', name: 'Romania' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'KR', name: 'South Korea' },
    { code: 'ES', name: 'Spain' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TR', name: 'Turkey' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'VN', name: 'Vietnam' }
  ];

  const massUpdateSitesType = async () => {
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'site_type', newSiteType)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "site_type", newSiteType, "Site type updated")
    setShowSiteTypeDialog(false)
    setNewSiteType(null)
  }

  const massUpdateSitesLocation = async () => {
    const results = await Promise.allSettled(
      checkedSites.map(async (site) => {
        try {
          await UpdateSiteDetails(site.uuid, 'country_code', newSiteLocation)
          return { uuid: site.uuid, success: true }
        } catch (error) {
          return { uuid: site.uuid, success: false, error }
        }
      })
    )
    const successfulUUIDs = results
      .filter(r => r.status === 'fulfilled' && r.value.success)
      .map(r => r.value.uuid)
    updateAndNotifySites(successfulUUIDs, "country_code", newSiteLocation, "Site location updated")
    setShowSiteLocationDialog(false)
    setNewSiteLocation(null)
  }

  const billableOptions = [
    { label: 'Yes (Billable)', value: "1" },
    { label: 'No (Not billable)', value: "0" },
    { label: 'Demo', value: "2" },
  ]

  const HandleMassReset = async () => {
    showLoadingModal();
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        resetSite(apiData, site.uuid, userID, "", dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      )
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    ShowActionCompleteModal(successes.length, fails.length, "reset")
  };

  const HandleMassSuspend = async () => {
    showLoadingModal();
    const allSuspended = checkedSites.every(site => site.status === "suspended");
    const action = allSuspended ? "available" : "suspended";
    const uuids = checkedSites.map(site => site.uuid)
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        suspendDevice(apiData, action, site.id, dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      ),

      setSiteDevices((prevSiteDevices) => {
        const uuidSet = new Set(uuids);
        return prevSiteDevices.map((device) =>
          uuidSet.has(device.uuid)
            ? { ...device, status: action }
            : device
        );
      })
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    const actionCompleted = action == "suspended" ? "suspended" : "unsuspended"
    ShowActionCompleteModal(successes.length, fails.length, actionCompleted)
  }

  const HandleMassDeactivate = async () => {
    showLoadingModal();
    const allActive = checkedSites.every(site => site.active == 1);
    let action = 1
    if (allActive) {
      action = 0
    }

    const popupText = action == 1 ? "activated" : "deactivated"
    const results = await Promise.allSettled(
      checkedSites.map(async site => {
        let body = {
          uuid: site.uuid,
          active: action
        };

        try {
          await setSiteActive(apiData, body, dispatch);
          return ({ uuid: site.uuid, success: true });
        } catch (error) {
          return ({ uuid: site.uuid, success: false, error });
        }
      })
    );
    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    setSiteDevices(prevSiteDevices =>
      prevSiteDevices.map(device =>
        successes.includes(device.uuid)
          ? { ...device, active: action }
          : device
      )
    );

    ShowActionCompleteModal(successes.length, fails.length, popupText)
  }

  const HandleMassLiveView = async () => {
    showLoadingModal();
    const allDisabled = checkedSites.every(site => site.liveViewEnabled == 0);
    let action = 0
    if (allDisabled) {
      action = 1
    }

    const popupText = action == 1 ? "enabled" : "disabled"
    const results = await Promise.allSettled(
      checkedSites.map(async site => {
        let body = {
          "uuid": site.uuid,
          "liveViewEnabled": action == 0 ? 0 : 1
        }

        try {
          await setSiteLiveView(apiData, body, dispatch);
          return ({ uuid: site.uuid, success: true });
        } catch (error) {
          return ({ uuid: site.uuid, success: false, error });
        }
      })
    );
    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    setSiteDevices(prevSiteDevices =>
      prevSiteDevices.map(device =>
        successes.includes(device.uuid)
          ? { ...device, liveViewEnabled: action }
          : device
      )
    );

    ShowActionCompleteModal(successes.length, fails.length, popupText)
  }

  const HandleSingleDeactivateSite = async (row) => {
    if (row.active == 0) {
      const owningGroup = groups?.find(g => g.name === row.name)
      if (company !== "EyeSpyFX" && !owningGroup?.billingEnabled) {
        setModalTitle("Account setup required")
        setModalComponent(
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px", maxWidth: "480px" }}>
            <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
              Unfortunately you are unable to make this site active as your company has not yet properly set up an account with Inniovate.
            </p>
            <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
              If your company has not yet formally set up an account with us, please do so here:<br/>
              <a href="https://inniovate.com/account-setup" target="_blank" rel="noreferrer" style={{ color: "rgb(41,140,182)" }}>https://inniovate.com/account-setup</a>
            </p>
            <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
              If you have set up an account, but have not set up Direct Debit, please click on this link to set up your company's Direct Debit:<br/>
              <a href="https://pay.gocardless.com/BRT0002ZAC41XYA" target="_blank" rel="noreferrer" style={{ color: "rgb(41,140,182)" }}>https://pay.gocardless.com/BRT0002ZAC41XYA</a>
            </p>
            <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
              Please make contact with your Inniovate sales representative if you are unable to set this up or have any queries.
            </p>
            <br/>
            <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity="secondary" />
          </div>
        )
        HandleShowModal()
        return
      }

      if (!row.tag || row.tag === "") {
        setModalTitle("Portal name required")
        setModalComponent(
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <p style={{ textAlign: "center", color: "#858585", fontSize: "15px" }}>A portal site name must be set before this site can be activated.</p>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button icon="pi pi-times" onClick={HandleCloseModal} label="Cancel" severity="secondary" />
              <Button icon="pi pi-pencil" label="Set portal name" severity="success" onClick={() => {
                setModalTitle("Change portal name")
                setModalComponent(
                  <SetTag
                    placeholder={row.tag}
                    DeviceUUID={row.uuid}
                    HandleCloseModal={HandleCloseModal}
                    dispatch={dispatch}
                    update={update}
                    setUpdate={setUpdate}
                    SiteDevices={SiteDevices}
                    setSiteDevices={setSiteDevices}
                    successModal={successModal}
                    errorModal={errorModal}
                    setUpdateTag={async () => {
                      const body = { uuid: row.uuid, active: 1 };
                      const activateResponse = await setSiteActive(apiData, body, dispatch);
                      if (activateResponse.success) {
                        setSiteDevices(prev =>
                          prev.map(device =>
                            device.uuid === row.uuid
                              ? { ...device, active: 1, dateMadeActive: new Date().toISOString() }
                              : device
                          )
                        );
                      }
                    }}
                  />
                )
              }} />
            </div>
          </div>
        )
        HandleShowModal()
        return
      }
    }

    let body = {
      uuid: row.uuid,
      active: row.active == 1 ? 0 : 1
    };

    const response = await setSiteActive(apiData, body, dispatch);
    if (response.success) {
      setSiteDevices((prevSiteDevices) =>
        prevSiteDevices.map((device) =>
          device.uuid === body.uuid ? { ...device, active: body.active, dateMadeActive: new Date() } : device
        )
      );
    }
  }

  const HandleMassClearLogs = async () => {
    showLoadingModal();
    const results = await Promise.allSettled(
      checkedSites.map(site =>
        clearDeviceLogs(apiData, site.uuid, userID, dispatch)
          .then(() => ({ uuid: site.uuid, success: true }))
          .catch((error) => ({ uuid: site.uuid, success: false, error }))
      )
    );

    const successes = results.filter(r => r.value?.success).map(r => r.value.uuid);
    const fails = results.filter(r => r.status === 'rejected' || r.value?.success === false).map(r => (r.reason?.uuid || r.value?.uuid));

    ShowActionCompleteModal(successes.length, fails.length, "cleared logs for")
  }

  const HandleMassAddToGroup = async () => {
    showLoadingModal();
    //const group = groups.find(group => group.name === dataManager.getItem('selectedGroup'))
    // if (!group) {
    //   console.error("Selected group not found");
    //   return;
    // }

    const uuids = checkedSites.map(site => site.uuid)
    const body = {
      groupID: selectedGroup.id,
      groupName: selectedGroup.name,
      groupDevices: uuids
    }

    const response = await addSitesToGroup(apiData, body, dispatch)
    if (response.success) {
      setAddToGroupVisible(false)
      setSiteDevices((prevSiteDevices) => {
        const uuidSet = new Set(uuids);
        if (isGroupSites) {
          return prevSiteDevices.filter((device) => !uuidSet.has(device.uuid));
        }
        return prevSiteDevices.map((device) =>
          uuidSet.has(device.uuid)
            ? { ...device, name: selectedGroup.name }
            : device
        );
      });
      setCheckedSites([]);
      ShowActionCompleteModal(uuids.length, 0, "added")
    }
  }

  const HandleMassAddUser = () => {

  }

  useEffect(() => {
    switch (selectedMassAction) {
      case "Reset sites": {
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to reset {checkedSites.length} sites?</h2>
            </div>
            <p style={{ textAlign: "center" }}>This will revert all settings & customisations to factory default.</p>
            <p style={{ textAlign: "center" }}>This action cannot be undone!</p>

            <br></br>
            <ChangeGroup
              apiData={apiData}
              DeviceUUID={""}
              companyName={""}
              NotificationTitle={""}
              label={"To change group, please select a new group below"}
              dropDownOptions={groups.map(group => group.name).sort((a, b) => a.localeCompare(b))}
              HandleCloseModal={HandleCloseModal}
              update={update}
              setUpdate={setUpdate}
              SiteDevices={SiteDevices}
              setSiteDevices={setSiteDevices}
            />
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button icon="pi pi-times"  onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check"  onClick={HandleMassReset} label="Yes, I'm sure" severity='success'/>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Suspend/Unsuspend sites": {
        const allSuspended = checkedSites.every(site => site.status === "suspended");
        const action = allSuspended ? "unsuspend" : "suspend";
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to {action} {checkedSites.length} sites?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
              <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check" onClick={HandleMassSuspend} label="Yes, I'm sure" severity='danger'/>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Clear event logs": {
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to delete {checkedSites.length} sites event logs?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
               <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check" onClick={HandleMassClearLogs} label="Yes, I'm sure" severity='danger'/>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Add sites to group": {
        setIsMassAction(true)

        setAddToGroupVisible(true)

        break;
      }
      case "Add users": {
        const sitesWithoutName = checkedSites.filter(site => !site.tag || site.tag === "");
        if (sitesWithoutName.length > 0) {
          setModalTitle("Portal name required")
          setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px" }}>
                A portal site name must be set before users can be added. The following {sitesWithoutName.length === 1 ? "site does" : "sites do"} not have a name set. You can do this by opening each site and clicking on the first tile on the Overview tab.
              </p>
              <ul style={{ margin: 0, textAlign: "left" }}>
                {sitesWithoutName.map(site => <li key={site.uuid}>{site.key}</li>)}
              </ul>
              <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity="secondary" />
            </div>
          )
          HandleShowModal()
          break;
        }
        // setModalTitle(`Add users to ${checkedSites.length} sites`)
        showAddUserModal();

        break;
      }
      case "Switch active status": {
        const allInactive = checkedSites.every(site => site.active === 0);
        const action = allInactive ? "activate " : "deactivate";
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to {action} {checkedSites.length} sites?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
               <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check" onClick={() => HandleMassDeactivate()} label="Yes, I'm sure" severity='danger'/>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Create permanent schedule": {
        setIsCreateScheduleOpen(true)
        break;
      }
      case "Set live view status": {
        const allDisabled = checkedSites.every(site => site.liveViewEnabled === 0);
        const action = allDisabled ? "enable " : "disable";
        setModalTitle("Are you sure?")
        setModalComponent(
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>Are you sure you want to {action} live view on {checkedSites.length} sites?</h2>
            </div>
            <br></br>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px"
            }}>
               <Button icon="pi pi-times"  onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check"  onClick={() => HandleMassLiveView()} label="Yes, I'm sure" severity='danger'/>
            </div>
          </div>
        )
        HandleShowModal();
        break;
      }
      case "Update billable": {
        setChangeBillable(true)
        break;
      }
      case "Update billed to": {
        setShowSelectBilledToDialog(true)
        break;
      }
      case "Update customer billed to": {
        setShowSelectCustomerBilledToDialog(true)
        break;
      }
      case "Update owned by": {
        setShowSelectOwnerDialog(true)
        break;
      }
      case "Update billing frequency": {
        setNewBillingFrequency(null)
        setShowBillingFrequencyDialog(true)
        break;
      }
      case "Update date of hardware invoice": {
        setNewDateOfSale(null)
        setShowDateOfSaleDialog(true)
        break;
      }
      case "Update date of 1st SaaS invoice": {
        setNewInvoiceDate(null)
        setShowInvoiceDateDialog(true)
        break;
      }
      case "Update date made active": {
        setNewDateMadeActive(null)
        setShowDateMadeActiveDialog(true)
        break;
      }
      case "Set site type": {
        setNewSiteType(null)
        setShowSiteTypeDialog(true)
        break;
      }
      case "Set site location": {
        setNewSiteLocation(null)
        setShowSiteLocationDialog(true)
        break;
      }
      default: {
        //do nothing?
      }
    }

  }, [selectedMassAction])

  const handleNextClick = () => {
    isMassAction ? AddSiteToGroup() : HandleMassAddToGroup();
  };

  useEffect(() => {
    if (success) {
      successModal(message, false)
      setSuccess(false)
    }

    if (failure) {
      errorModal(message, false)
      setFail(false)
    }
  }, [success, failure])

  const showCompleteAddModal = () => {
    setModalTitle("Please wait…");
    setIsCompleteModalOpen(true);
    setIsAddUserModalOpen(false)
  };

  const hideCompleteAddModal = () => {
    if (isCompleteModalOpen) {
      setIsCompleteModalOpen(false)
      setSelectedMassAction("")
      setModalMessageSuccess("")
      setModalMessageFail("")
    }
  }

  const showAddUserModal = () => {
    setModalTitle("Add users");
    setIsAddUserModalOpen(true)
  };

  

  const columnDefs = (() => {
    const defs = tablecolumns
      .filter(col => col.filterLabel)
      .map(col => ({ key: col.id, label: col.filterLabel, visible: !col.hidden }));
    if (!columnOrder.length) return defs;
    return [...defs].sort((a, b) => {
      const ai = columnOrder.indexOf(a.key);
      const bi = columnOrder.indexOf(b.key);
      return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
    });
  })();

  return (
    <>
      {/* Temporarily disabled until backend supports includeSubUsers */}
      {false && (
      <Dialog
        header="Remove user"
        visible={removeSubUsersDialogVisible}
        style={{ width: "420px" }}
        onHide={() => setRemoveSubUsersDialogVisible(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <p style={{ margin: 0, color: "#4a4a4a", fontSize: "14px" }}>Would you also like to remove users that this person invited to the site?</p>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Button
              label="Remove user only"
              icon="pi pi-user-minus"
              severity="danger"
              outlined
              onClick={() => { setRemoveSubUsersDialogVisible(false); pendingRemoveAction && pendingRemoveAction(false); }}
            />
            <Button
              label="Remove user and their invited users"
              icon="pi pi-users"
              severity="danger"
              onClick={() => { setRemoveSubUsersDialogVisible(false); pendingRemoveAction && pendingRemoveAction(true); }}
            />
          </div>
          <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={() => setRemoveSubUsersDialogVisible(false)} />
        </div>
      </Dialog>
      )}

      <Dialog
        header="Column visibility"
        visible={columnSettingsVisible}
        style={{ width: "360px" }}
        onHide={() => setColumnSettingsVisible(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {columnDefs
            .filter(({ key }) => company === "EyeSpyFX" || !['billable', 'billedToGID', 'billingFrequency', 'dateOfSale', 'recentInvoice'].includes(key))
            .map(({ key, label, visible }, index, arr) => (
            <div key={key} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <Button
                  icon="pi pi-angle-up"
                  text
                  severity="secondary"
                  style={{ padding: "2px 4px", width: "24px", height: "20px" }}
                  disabled={index === 0}
                  onClick={() => moveColumn(key, -1)}
                />
                <Button
                  icon="pi pi-angle-down"
                  text
                  severity="secondary"
                  style={{ padding: "2px 4px", width: "24px", height: "20px" }}
                  disabled={index === arr.length - 1}
                  onClick={() => moveColumn(key, 1)}
                />
              </div>
              <Checkbox
                inputId={`col-${key}`}
                checked={visible}
                onChange={() => toggleColumnVisibility(key, visible)}
              />
              <label htmlFor={`col-${key}`} style={{ cursor: "pointer", fontSize: "14px" }}>{label}</label>
            </div>
          ))}
        </div>
      </Dialog>

      <CopySiteConfigForm
        apiData={apiData}
        visible={copyConfigData !== null}
        setIsVisible={(visible) => { if (!visible) setCopyConfigData(null); }}
        siteIdentifier={copyConfigData?.siteIdentifier || ""}
        groups={groups}
        deviceFromUUID={copyConfigData?.deviceFromUUID || ""}
        userID={copyConfigData?.userID || ""}
        deviceFromID={copyConfigData?.deviceFromID || ""}
      />

      <Dialog
        header="Add to group"
        visible={addToGroupVisible}
        style={{ width: "40vw" }}
        onHide={() => setAddToGroupVisible(false)}
      >
        <div>
          <p>Choose new group from the dropdown below</p>
          <Dropdown
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.value)}
            options={groups}
            optionLabel="name"
            showClear
            filter
            placeholder="Select a group"
            className="w-full md:w-14rem" />
        </div>

        <br></br>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button icon="pi pi-check"  label="Next" severity="success" disabled={!selectedGroup} onClick={() => isMassAction ? HandleMassAddToGroup() : AddSiteToGroup()} />
        </div>
      </Dialog>

      <Dialog
        header="Success"
        visible={successVisible}
        style={{ width: "30vw" }}
        onHide={() => setSuccessVisible(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <h3 style={{ color: "#6e6e6eff" }}>Action complete!</h3>
          <Lottie
            animationData={successAnim}
            loop={false}
            style={{ width: 250, height: 250, margin: "0px" }}
          />

          <Button label="Close" icon="pi pi-times" severity="primary" onClick={() => setSuccessVisible(false)} />
        </div>
      </Dialog>


      <div className="card flex justify-content-center">
        {isCompleteModalOpen && 
        (<Dialog header="Adding users..." 
          visible={isCompleteModalOpen} 
          style={{ width: '30vw' }} 
          onHide={() => { if (!isCompleteModalOpen) return; setIsCompleteModalOpen(false); }}>
          <div className="flex flex-col items-center justify-center">

          <p style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center", fontSize:"18px", fontWeight:600 }}>{`Site ${currentSitePosition} of ${checkedSites.length}`}</p>
          <p style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center", fontSize:"18px", fontWeight:600 }}>{`User ${currentUserPosition} of ${totalUsers}`}</p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Lottie
                animationData={loadingAnim}
                loop
                style={{ width: 250, height: 250 }}
              />
            </div>

              
            {/* white-space:pre-line shows each “\n” on its own line */}
             

            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {modalMessageSuccess || ""}
            </h3>

            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {modalMessageFail || ""}
            </h3>

            <br />
            <br/>
               <Button icon="pi pi-times"  onClick={hideCompleteAddModal} label="Cancel" severity='secondary'/>
          </div>
        </Dialog>)}
      </div>

      <div className="card flex justify-content-center">
        {isAddUserModalOpen && (
          <Dialog 
            header={`Add users to ${checkedSites.length} site(s)`} 
            visible={isAddUserModalOpen} 
            style={{ width: '50vw', height:'50vw' }} 
            onHide={() => { if (!isAddUserModalOpen) return; setIsAddUserModalOpen(false); }}
          >
            <MassAddUserForm
              apiData={apiData}
              sites={checkedSites}
              userID={userID}
              HandleCloseModal={HandleCloseModal}
              companyName={company}
              showAddingUsersModal={showCompleteAddModal}
              setModalMessageSuccess={setModalMessageSuccess}
              setModalMessageFail={setModalMessageFail} 
              successVisible={successVisible}
              setSuccessVisible={setSuccessVisible}
              setIsCompleteModalOpen={setIsCompleteModalOpen}
              currentSitePosition={currentSitePosition}
              setCurrentSitePosition={setCurrentSitePosition}
              currentUserPosition={currentUserPosition}
              setCurrentUserPosition={setCurrentUserPosition}
              totalUsers={totalUsers}
              setTotalUsers={setTotalUsers}
              liveViewEnabled={checkedSites.some(s => s.liveViewEnabled == 1) ? 1 : 0}/>
          </Dialog>)}
      </div>

      <div className="card flex justify-content-center">
        {isCreateScheduleOpen && (
          <Dialog 
            header={`Create permanent schedule for ${checkedSites.length} site(s)`}
            visible={isCreateScheduleOpen}
            style={{ width: 'clamp(360px, 50vw, 680px)' }}
            onHide={() => { if (!isCreateScheduleOpen) return; setIsCreateScheduleOpen(false); }}
          >
            <CreateMassScheduleForm
              selectedSites={checkedSites}
              apiData={apiData}
            />
            
          </Dialog>)}
      </div>

      <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal}>
        {modalComponent}
      </Modal>

      <Dialog
        header={`Update billing status for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={changeBillable}
        style={{ width: '30vw' }}
        onHide={() => { setChangeBillable(false); setNewBillableStatus(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Dropdown
            placeholder="Select status"
            options={billableOptions}
            optionLabel="label"
            optionValue="value"
            value={newBillableStatus}
            onChange={(e) => setNewBillableStatus(e.value)}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <Button icon="pi pi-times" label="Cancel" onClick={() => { setChangeBillable(false); setNewBillableStatus(null); }} className="p-button-secondary" />
          <Button icon="pi pi-save" label="Save" onClick={() => { massUpdateSitesBillable(newBillableStatus); setChangeBillable(false); setNewBillableStatus(null); }} disabled={newBillableStatus === null} />
        </div>
      </Dialog>

      {showSelectBilledToDialog && (
        <SelectGroupDialog
          title="Select the group to be billed"
          visible={showSelectBilledToDialog}
          onHide={() => setShowSelectBilledToDialog(false)}
          groupNames={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
          functionToCall={(selectedGroup) => massUpdateSitesBilledTo(selectedGroup)}
        />
      )}

      {showSelectOwnerDialog && (
        <SelectGroupDialog
          title="Select the new owner"
          visible={showSelectOwnerDialog}
          onHide={() => setShowSelectOwnerDialog(false)}
          groupNames={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
          functionToCall={(selectedGroup) => massUpdateSitesOwnedBy(selectedGroup)}
        />
      )}

      {showSelectCustomerBilledToDialog && (
        <SelectGroupDialog
          title="Select the group to bill the customer"
          visible={showSelectCustomerBilledToDialog}
          onHide={() => setShowSelectCustomerBilledToDialog(false)}
          groupNames={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
          functionToCall={(selectedGroup) => massUpdateSitesCustomerBilledTo(selectedGroup)}
        />
      )}

      <Dialog
        header={`Set billing frequency for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showBillingFrequencyDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowBillingFrequencyDialog(false); setNewBillingFrequency(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Dropdown
            placeholder="Select frequency"
            options={billingOptions}
            value={newBillingFrequency}
            onChange={(e) => setNewBillingFrequency(e.value)}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowBillingFrequencyDialog(false); setNewBillingFrequency(null); }} className="p-button-secondary" />
          <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesBillingFrequency} disabled={!newBillingFrequency} />
        </div>
      </Dialog>

      <Dialog
        header={`Set date of sale for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showDateOfSaleDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowDateOfSaleDialog(false); setNewDateOfSale(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Calendar
            value={newDateOfSale}
            onChange={(e) => setNewDateOfSale(e.value)}
            dateFormat="dd/mm/yy"
            showIcon
            inline
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
            <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowDateOfSaleDialog(false); setNewDateOfSale(null); }} className="p-button-secondary" />
            <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesDateOfSale} disabled={!newDateOfSale} />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={`Set invoice date for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showInvoiceDateDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowInvoiceDateDialog(false); setNewInvoiceDate(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Calendar
            value={newInvoiceDate}
            onChange={(e) => setNewInvoiceDate(e.value)}
            dateFormat="dd/mm/yy"
            showIcon
            inline
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
            <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowInvoiceDateDialog(false); setNewInvoiceDate(null); }} className="p-button-secondary" />
            <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesInvoiceDate} disabled={!newInvoiceDate} />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={`Set date made active for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showDateMadeActiveDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowDateMadeActiveDialog(false); setNewDateMadeActive(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Calendar
            value={newDateMadeActive}
            onChange={(e) => setNewDateMadeActive(e.value)}
            dateFormat="dd/mm/yy"
            showIcon
            inline
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
            <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowDateMadeActiveDialog(false); setNewDateMadeActive(null); }} className="p-button-secondary" />
            <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesDateMadeActive} disabled={!newDateMadeActive} />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={`Set site type for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showSiteTypeDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowSiteTypeDialog(false); setNewSiteType(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Dropdown
            placeholder="Select site type"
            options={siteTypeOptions}
            optionLabel="label"
            optionValue="key"
            value={newSiteType}
            onChange={(e) => setNewSiteType(e.value)}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowSiteTypeDialog(false); setNewSiteType(null); }} className="p-button-secondary" />
          <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesType} disabled={!newSiteType} />
        </div>
      </Dialog>

      <Dialog
        header={`Set site location for ${checkedSites.length} site${checkedSites.length !== 1 ? 's' : ''}`}
        visible={showSiteLocationDialog}
        style={{ width: '30vw' }}
        onHide={() => { setShowSiteLocationDialog(false); setNewSiteLocation(null); }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Dropdown
            placeholder="Select country"
            options={countryCodeOptions}
            optionLabel="name"
            optionValue="code"
            filter
            value={newSiteLocation}
            onChange={(e) => setNewSiteLocation(e.value)}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowSiteLocationDialog(false); setNewSiteLocation(null); }} className="p-button-secondary" />
          <Button icon="pi pi-save" label="Save" onClick={massUpdateSitesLocation} disabled={!newSiteLocation} />
        </div>
      </Dialog>

      <div className={(!isUsersSites && !isLiveViewSites && !isGroupSites) ? `${classes.table} ${classes.center} ` : `${classes.tableUserDevices} ${classes.center} `}>
        <ListCard secondaryClassName={classes["Card-container"]}>
          <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "0px 10px 0px 10px" }}>
            <Suspense fallback={
              <div className={classes["loadingSpinner-container"]}>
                <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
              </div>}>

              {(showMassSettings && !addAccessMode && !editUserAccess && !groupMode && !sitesForGroupMode) && (
                <div style={{ marginTop: "3px", marginBottom: "5px" }}>
                  <Dropdown value={selectedMassAction} onChange={(e) => setSelectedMassAction(e.value)} options={filteredMassActionOptions}
                    placeholder="Select an action" className="w-full md:w-14rem" />
                  {checkedSites.length > 0 && <Button label='Clear selections' outlined severity='danger' icon="pi pi-times" style={{ fontSize: "12px", width: "160px", padding: 12, marginLeft: "15px" }} onClick={() => setCheckedSites([])} />}
                </div>
              )}

              <div style={{ width: "auto", minWidth: "1000px", height: "100%", minHeight: "500px" }} >
                    {(groupMode || addAccessMode || editUserAccess || sitesForGroupMode) && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: "0px", marginBottom: "0px" }}>
                          <input
                            type="checkbox"
                            id={`checkbox`}
                            className={classes["circular-checkbox"]}
                            onChange={() => HandleSelectAll()}
                          />
                          <label
                            style={{
                              marginRight: "10px",
                              marginLeft: "10px",
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            htmlFor={`checkbox`}
                            className={classes['custom-checkbox']}
                          />
                          <span>Select all</span>
                        </div>
                      </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
                      <Button
                        icon="pi pi-table"
                        text
                        severity="secondary"
                        onClick={() => setColumnSettingsVisible(true)}
                        title="Show/hide columns"
                        style={{ padding: "4px 8px" }}
                      />
                    </div>
                    <BasicTable
                      data={SiteDevices}
                      columns={tableColumnsFiltered}
                      allColumns={tableColumnsFiltered}
                      filtering={filtering}
                      rowClick={false}
                      ShowPagination={false}
                      PageSize={5000}
                      paginationOptions={[25, 50, 100]}
                      showFilterButton={false}
                      isSortable={isSortable}
                    />
              </div>
            </Suspense>
            <br></br>
            <br></br>
            {!hideControls && (
              <GridPaginationControls
                pageIndex={pageFetchedIndex}
                nextPage={HandleNextPage}
                previousPage={HandlePreviousPage}
                setPageIndex={HandleSetPageIndex}
                pageCount={totalPages}
                setPageSize={HandlePageSize}
                PageSize={pageSize}
                totalDevices={totalDevices}
                setTotalDevices={setTotalDevices}
                hidePageSize={offlineOnly}
              />
            )}
          </div>
        </ListCard>
      </div>
    </>
  )
}

export default DevicesList;